import React, { useEffect, useMemo, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import "../../../assets/topstudio/styles/CardsSprite.css";
import "../../../assets/topstudio/styles/roulet.css";
import "../../../assets/topstudio/styles/aviator.css";
import useSocket from "../../../hooks/useSocket";
import axiosInstance from "../../../utils/axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Ball from "../../../assets/topstudio/images/CricX/ball.png";
import Ballbgfiremoving from "../../../assets/topstudio/images/CricX/ballbgfiremoving.png";
import Baller from "../../../assets/topstudio/images/CricX/baller.png";
import Ballerscreen from "../../../assets/topstudio/images/CricX/ballerseen.png";
import Ballerthrowing from "../../../assets/topstudio/images/CricX/ballerthrowing.png";
import Ballflame from "../../../assets/topstudio/images/CricX/ballflame.png";
import Ballerthrowing2 from "../../../assets/topstudio/images/CricX/ballerthrowing2.png";
import Batsman1 from "../../../assets/topstudio/images/CricX/batsman1.png";
import Batsman2 from "../../../assets/topstudio/images/CricX/batsman2.png";
import Batsman3 from "../../../assets/topstudio/images/CricX/batsman3.png";
import Batsman4 from "../../../assets/topstudio/images/CricX/batsman4.png";
import Batsman5 from "../../../assets/topstudio/images/CricX/batsman5.png";
import Cloud1 from "../../../assets/topstudio/images/CricX/cloud1.png";
import Cloud2 from "../../../assets/topstudio/images/CricX/cloud2.png";
import Cloud3 from "../../../assets/topstudio/images/CricX/cloud3.png";
import Cloud4 from "../../../assets/topstudio/images/CricX/cloud4.png";
import Girlwithfl from "../../../assets/topstudio/images/CricX/girlwithfl.png";
import Girlwithfl2 from "../../../assets/topstudio/images/CricX/girlwithfl2.png";
import Girlwithflst from "../../../assets/topstudio/images/CricX/girlwithflst.png";
import Girlwithflst2 from "../../../assets/topstudio/images/CricX/girlwithflst2.png";
import Keeper from "../../../assets/topstudio/images/CricX/keeper.png";
import Running from "../../../assets/topstudio/images/CricX/running.gif";
import BgSound from "../../../assets/topstudio/audio/aviatorbg.mp3";

import AvaitorResult from "../../client/tp-studio/tp-result/AvaitorResult.jsx";

import "../../../assets/topstudio/styles/CricX.css";
import CricketRules from "./pop-up/cricketx-rules";
import "./Aviator.scoped.css";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import { Check, X } from "lucide-react";

/** Timing & flight settings */
const STEP = 0.01;
const STEP_MS = 91;
const SLOW_UNTIL = 1.1;
const SLOW_DURATION_MS = 2000;
const SLOW_RANGE_STEPS = Math.round((SLOW_UNTIL - 1) / STEP);
const SLOW_STEP_MS = SLOW_DURATION_MS / SLOW_RANGE_STEPS;
const CASHOUT_MIN_MULTIPLIER = 1;
const SERVER_TICK_MS = 1000; // filler uses 200ms then 91ms. This is only the first gap.
const LUCKY_PLAN_TARGET = 3.5; // dummy cashouts without knowing the crash

function formatWinToastAmount(amount) {
  const n = parseFloat(amount);
  if (Number.isNaN(n)) return "0";
  if (Math.abs(n - Math.round(n)) < 0.001) return String(Math.round(n));
  return n.toFixed(2);
}

function showWinToast(amount) {
  const display = formatWinToastAmount(amount);
  toast(
    <div className="av-toast-body">
      <span className="av-toast-icon">
        <Check size={24} color="#ffffff" strokeWidth={3} aria-hidden="true" />
      </span>
      <span className="av-toast-text">You won {display}</span>
    </div>,
    {
      toastId: "cricketx-win-toast",
      className: "av-win-toast",
      icon: false,
      closeButton: false,
      autoClose: 1500,
      hideProgressBar: false,
      position: "top-center",
    }
  );
}

function showLostToast(amount) {
  const display = formatWinToastAmount(amount);
  toast.dismiss("cricketx-win-toast");
  toast(
    <div className="av-toast-body">
      <span className="av-toast-icon">
        <X size={24} color="#ffffff" strokeWidth={3} aria-hidden="true" />
      </span>
      <span className="av-toast-text">You lost {display}</span>
    </div>,
    {
      toastId: `cricketx-lost-${Date.now()}`,
      className: "av-lost-toast",
      icon: false,
      closeButton: false,
      autoClose: 1500,
      hideProgressBar: false,
      position: "top-center",
    }
  );
}

function showBetPlacedToast() {
  toast(
    <div className="av-toast-body">
      <span className="av-toast-icon">
        <Check size={24} color="#ffffff" strokeWidth={3} aria-hidden="true" />
      </span>
      <span className="av-toast-text">Order Placed</span>
    </div>,
    {
      toastId: "cricketx-bet-placed-toast",
      className: "av-bet-toast",
      icon: false,
      closeButton: false,
      autoClose: 1000,
      hideProgressBar: false,
      position: "top-right",
    }
  );
}

/** Matches launch countdown ticks */
const COUNTDOWN_BET_SECONDS = 4;
const MIN_CRASH_HOLD_MS = 4000;
const DEFAULT_NEXT_ROUND_HOLD_MS = 5000;
const PRE_FLIGHT_STREAM_WINDOW_MS = (COUNTDOWN_BET_SECONDS + 2) * 1000;

const nextRoundHoldMsFromPayload = (livePayload) => {
  const sec = Number(
    livePayload?.next_round_delay ?? livePayload?.time_bet
  );
  const fromPayload =
    Number.isFinite(sec) && sec > 0
      ? Math.round(sec * 1000)
      : DEFAULT_NEXT_ROUND_HOLD_MS;
  return Math.max(MIN_CRASH_HOLD_MS, fromPayload);
};

const sameEvtId = (a, b) =>
  a != null && b != null && String(a) === String(b);

/** One "Getting the bets" bar cycle (full green hold + drain); drives CSS duration + overlay hide delay */
const FETCH_BET_ANIM_MS = 3000;

/** Cricket intro: cheer girls -> umpire -> run-up -> throw -> hit -> sky */
const INTRO_STEPS = [
  { name: "show1", ms: 1800 },
  { name: "show2", ms: 1800 },
  { name: "bowler", ms: 1800 },
  { name: "run", ms: 1400 },
  { name: "throw", ms: 1400 },
  { name: "hit", ms: 1400 },
  { name: "ball-flight", ms: 1400 }
];
/** After "GETTING THE BETS" on show1, gameplay intro starts here */
const GAME_ANIM_START_STEP = "show2";

const normalizeResultsList = (data) => {
  if (data == null) return [];
  const values = Array.isArray(data) ? data : Object.values(data);
  return values
    .filter((v) => v !== null && v !== undefined && v !== "")
    .map((v) => parseFloat(v))
    .filter((v) => !Number.isNaN(v));
};

const parseServerSeconds = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? Math.max(0, n) : null;
};

const RESULT_SYNC_BUFFER = 0.02;

const getTotalFlightSteps = (target) =>
  Math.max(1, Math.round((target - 1) / STEP) + 1);

const getFlightDurationSec = (target) =>
  (getTotalFlightSteps(target) - 1) * (STEP_MS / 1000);

/** Where the flight clock should stand for a given multiplier (2s slow start, then 91ms ticks). */
const elapsedMsFromMultiplier = (value, skipSlowStart) => {
  const v = Math.max(1, Number(value) || 1);
  if (skipSlowStart) {
    const steps = Math.max(0, Math.round((v - 1) / STEP));
    return steps * STEP_MS;
  }
  if (v <= SLOW_UNTIL + 0.0001) {
    const steps = Math.max(0, Math.round((v - 1) / STEP));
    return steps * SLOW_STEP_MS;
  }
  const extraSteps = Math.max(0, Math.round((v - SLOW_UNTIL) / STEP));
  return SLOW_DURATION_MS + extraSteps * STEP_MS;
};

/** Never exceed crash result; stay a hair below when joining near the end */
const clampSyncedFlightValue = (value, target) => {
  let v = Math.min(Math.max(1, value), target);
  const safeCeiling = +(target - RESULT_SYNC_BUFFER).toFixed(2);
  if (safeCeiling >= 1 && v > safeCeiling) {
    v = safeCeiling;
  }
  return +v.toFixed(2);
};

const cricketXStepToValue = (step) => +(1 + (step - 1) * STEP).toFixed(2);

const cricketXValueToStep = (value, target) => {
  const totalSteps = getTotalFlightSteps(target);
  const step = Math.round((value - 1) / STEP) + 1;
  return Math.min(totalSteps, Math.max(1, step));
};

/**
 * Mid-flight reload sync — left_time is elapsed seconds since flight started.
 * Maps elapsed time onto the result-scaled flight window.
 */
const getFlightSyncFromLeftTime = (target, leftTime) => {
  const elapsed = parseServerSeconds(leftTime);
  if (elapsed == null) return null;

  const flightDurationSec = getFlightDurationSec(target);
  if (flightDurationSec <= 0) return null;

  const elapsedSec = Math.max(0, Math.min(flightDurationSec, elapsed));
  const progress = elapsedSec / flightDurationSec;

  let value = 1 + progress * (target - 1);
  value = clampSyncedFlightValue(value, target);

  const step = cricketXValueToStep(value, target);
  const finalValue = clampSyncedFlightValue(
    cricketXStepToValue(step),
    target
  );
  const finalStep = cricketXValueToStep(finalValue, target);

  return {
    step: finalStep,
    value: finalValue,
    elapsedMs: (finalStep - 1) * STEP_MS
  };
};

const MUSLIM_NAMES = [
  "Muhammad", "Ahmed", "Ali", "Hassan", "Hussein", "Omar", "Usman", "Bilal",
  "Hamza", "Yusuf", "Ibrahim", "Khalid", "Tariq", "Imran", "Farhan", "Saeed",
  "Rashid", "Nadeem", "Asif", "Faisal", "Zubair", "Salman", "Waqas", "Junaid",
  "Aamir", "Shahid", "Noman", "Rehan", "Sajid", "Kamran", "Arif", "Javed",
  "Fatima", "Aisha", "Zainab", "Maryam", "Khadija", "Hafsa", "Sana", "Hina",
  "Rabia", "Nadia", "Samina", "Shazia", "Farah", "Sadia", "Ayesha", "Bushra",
  "Uzma", "Nazia", "Saima", "Rubina", "Tahira", "Yasmin", "Amna", "Laiba",
  "Mahnoor", "Hira", "Kinza", "Aliza", "Danish", "Haroon", "Majid", "Rizwan"
];

const luckyRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const maskLuckyPlayerName = (name) => {
  if (!name) return "****";
  const visible = name.slice(0, Math.min(4, name.length));
  return `${visible}****`;
};

const formatLuckyPlayerAmount = (value) =>
  Number(value).toLocaleString("en-IN");

/** profit = (size × price) − size */
const calcLuckyPlayerProfit = (price, amountRaw) => {
  const priceNum = parseFloat(price);
  const amount = Number(amountRaw);
  if (!Number.isFinite(priceNum) || !Number.isFinite(amount) || amount <= 0) {
    return "";
  }
  const profit = priceNum * amount - amount;
  return formatLuckyPlayerAmount(Math.round(profit));
};

const LUCKY_RESERVE_FRACTION = 0.12;
const LUCKY_MIN_RESERVE = 8;
const LUCKY_MAX_RESERVE = 25;
const LUCKY_MIN_STEP_GAP = 5;

const luckyBetIsOpen = (bet) =>
  !bet.locked && (bet.rate === "--" || bet.profit === "" || bet.profit == null);

const pickRandomOpenBetIds = (bets, count, reserveCount = 0) => {
  const open = bets.filter(luckyBetIsOpen);
  const maxPickable = Math.max(0, open.length - reserveCount);
  if (maxPickable <= 0) return new Set();
  const n = Math.min(count, maxPickable);
  const shuffled = [...open].sort(() => Math.random() - 0.5);
  return new Set(shuffled.slice(0, n).map((bet) => bet.id));
};

const applyRandomLuckyCashoutBatch = (bets, price, batchSize, reserveCount = 0) => {
  const selectedIds = pickRandomOpenBetIds(bets, batchSize, reserveCount);
  if (!selectedIds.size) return bets;
  return bets.map((bet) =>
    selectedIds.has(bet.id) ? lockLuckyBetAtPrice(bet, price) : bet
  );
};

const applyLuckyCashoutEvents = (bets, events, reserveCount) =>
  events.reduce(
    (acc, event) =>
      applyRandomLuckyCashoutBatch(
        acc,
        event.value.toFixed(2),
        event.batchSize,
        reserveCount
      ),
    bets
  );

const cricketXStepToFlightValue = (step, target) =>
  clampSyncedFlightValue(cricketXStepToValue(step), target);

/** Spread cashouts evenly across the flight; leave a slice of bets blank until the end */
const buildLuckyCashoutPlan = (target, totalBets) => {
  const reserveCount = Math.min(
    totalBets - 1,
    Math.max(
      LUCKY_MIN_RESERVE,
      Math.min(LUCKY_MAX_RESERVE, Math.ceil(totalBets * LUCKY_RESERVE_FRACTION))
    )
  );
  const toCashOut = Math.max(0, totalBets - reserveCount);
  const totalSteps = getTotalFlightSteps(target);
  const startStep = Math.max(1, Math.floor(totalSteps * 0.08));
  const endStep = Math.max(startStep + 1, Math.floor(totalSteps * 0.9));
  const usableSteps = endStep - startStep;
  const maxWaves = Math.max(1, Math.floor(usableSteps / LUCKY_MIN_STEP_GAP));
  const waveCount = Math.min(toCashOut, maxWaves);

  if (waveCount <= 0 || toCashOut <= 0) {
    return { events: [], reserveCount, nextEventIndex: 0 };
  }

  const baseBatch = Math.floor(toCashOut / waveCount);
  let remainder = toCashOut % waveCount;
  const events = [];

  for (let i = 0; i < waveCount; i++) {
    const step =
      waveCount === 1
        ? Math.floor((startStep + endStep) / 2)
        : startStep + Math.round((i / (waveCount - 1)) * usableSteps);
    const value = cricketXStepToFlightValue(step, target);
    let batchSize = baseBatch + (remainder > 0 ? 1 : 0);
    if (remainder > 0) remainder -= 1;
    if (batchSize > 0) events.push({ value, batchSize });
  }

  return { events, reserveCount, nextEventIndex: 0 };
};

const lockLuckyBetAtPrice = (bet, price) => {
  if (bet.locked) return bet;
  return {
    ...bet,
    rate: price,
    profit: calcLuckyPlayerProfit(price, bet.amountRaw),
    locked: true
  };
};

const createDummyLuckyBet = () => {
  const baseName =
    MUSLIM_NAMES[luckyRandomInt(0, MUSLIM_NAMES.length - 1)];
  const name = `${baseName}${luckyRandomInt(10, 99)}`;
  const amount = luckyRandomInt(3, 50) * 1000;

  return {
    id: `live-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    uname: maskLuckyPlayerName(name),
    amount: formatLuckyPlayerAmount(amount),
    amountRaw: amount,
    rate: "--",
    profit: ""
  };
};

const createDummyBetQueue = () => {
  const count = luckyRandomInt(100, 180);
  return Array.from({ length: count }, createDummyLuckyBet);
};

const parseLuckyPlayerEntry = (entry, { isUser = false, betId = null } = {}) => {
  try {
    const obj = typeof entry === "string" ? JSON.parse(entry) : entry;
    const id = betId || obj._id || obj.bet_id;
    if (!id) return null;

    const name = obj.uname || "";
    const amountRaw = Number(obj.lockamt || obj.delivery || obj.amount || 0);
    const rateVal = obj.rate;
    const rateNum = parseFloat(rateVal);
    const hasCashout =
      rateVal != null &&
      rateVal !== "" &&
      rateVal !== "-" &&
      rateVal !== "--" &&
      Number.isFinite(rateNum) &&
      rateNum > 1;
    const rate = hasCashout ? Number(rateNum).toFixed(2) : "--";
    const profit =
      hasCashout && amountRaw ? calcLuckyPlayerProfit(rate, amountRaw) : "";

    return {
      id: String(id),
      betId: id,
      sectionNo: obj.section_no,
      uname: maskLuckyPlayerName(name),
      amount: formatLuckyPlayerAmount(amountRaw),
      amountRaw,
      rate,
      profit,
      locked: hasCashout,
      isUser
    };
  } catch {
    return null;
  }
};

const buildUserRecordsFromReturnBets = (returnBets, amounts, displayName) =>
  returnBets
    .filter((bet) => bet?.bet_id)
    .map((returnBet, idx) => {
      const betId = String(returnBet.bet_id);
      const amountRaw = Number(amounts[idx] || 0);
      return {
        id: betId,
        betId,
        sectionNo: returnBet.section_no,
        uname: maskLuckyPlayerName(displayName),
        amount: formatLuckyPlayerAmount(amountRaw),
        amountRaw,
        rate: "--",
        profit: "",
        locked: false,
        isUser: true
      };
    });

export default function CricketX() {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  const [showRules, setShowRules] = useState(false);
  const [open, setOpen] = useState(false);
  const [scene, setScene] = useState("loading");
  const [launchCountdown, setLaunchCountdown] = useState(COUNTDOWN_BET_SECONDS);
  /** True while place-bet request runs and/or fetch bar animation is finishing */
  const [isPlacingBets, setIsPlacingBets] = useState(false);
  /** Cheer-girls hold with GETTING THE BETS until the next round takes off */
  const [showRoundGettingBets, setShowRoundGettingBets] = useState(false);
  /** Bumps so the bar animation remounts once per place-bet call */
  const [fetchBetAnimKey, setFetchBetAnimKey] = useState(0);
  const fetchBetAnimStartRef = useRef(0);
  const fetchBetAnimHideTimeoutRef = useRef(null);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [resultData, setResultData] = useState([]);

  const lastTenResults = useMemo(
    () => normalizeResultsList(resultData).slice(0, 10),
    [resultData]
  );

  /** Cricket intro sub-phase (cycles during countdown) */
  const [introPhase, setIntroPhase] = useState("show1");
  const [takeoffPending, setTakeoffPending] = useState(false);
  const [triger, setsmallTriger] = useState("");
  const [ballerState, setballerState] = useState(Baller);
  const [batterState, setbatterState] = useState(Batsman1);
  const [ballFlame, setballFlame] = useState(Ballflame);
  const [count, setCount] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  /** Flight state */
  const [running, setRunning] = useState(false);
  const [flightValue, setFlightValue] = useState(0);
  const [isAudioOmitted, setIsAudioOmitted] = useState(false);

  /** Audio */
  const bgAudioRef = useRef(null);

  const rafRef = useRef(null);
  const startTsRef = useRef(null);
  const lastStepRef = useRef(-1);
  const skipStartHoldRef = useRef(false);
  const flightValueRef = useRef(0);
  const cashOutNowRef = useRef(null);
  const placeAllBetsNowRef = useRef(null);
  const isAudioOmittedRef = useRef(false);
  const leftBetAmountRef = useRef(100);
  const rightBetAmountRef = useRef(100);
  const leftMainBetIdRef = useRef("");
  const rightMainBetIdRef = useRef("");
  const leftBetGameIdRef = useRef("");
  const rightBetGameIdRef = useRef("");
  const leftIsCashingOutRef = useRef(false);
  const rightIsCashingOutRef = useRef(false);
  const lostToastEvtRef = useRef(null);
  const pendingLostToastEvtRef = useRef(null);
  const counterRawRef = useRef(null);
  const capTsRef = useRef(0);
  const capFromRef = useRef(1);
  const capIntervalRef = useRef(SERVER_TICK_MS);

  /** Server running_result is the live cap; crash only when CLOSED publishes result */
  const maxFlightRef = useRef(null);
  const crashKnownRef = useRef(false);
  const lastServerRunningRef = useRef(1);

  /** ===== Betting state (LEFT) ===== */
  const [leftBetAmount, setLeftBetAmount] = useState(100);
  const [leftBetErrorMessage, setLeftBetErrorMessage] = useState({});
  const [leftBetButtonShow, setLeftBetButtonShow] = useState(true);
  const [leftBetArray, setLeftBetArray] = useState([]);
  const leftBetArrayRef = useRef([]);
  const [leftMainBetId, setLeftMainBetId] = useState("");
  const [leftCashOutAmount, setLeftCashOutAmount] = useState("");
  const [leftShowCashoutButton, setLeftShowCashoutButton] = useState(false);
  const [leftIsCashingOut, setLeftIsCashingOut] = useState(false);
  const leftBetPlacedRef = useRef(false);
  const [leftBetGameId, setLeftBetGameId] = useState("");

  /** ===== Betting state (RIGHT) ===== */
  const [rightBetAmount, setRightBetAmount] = useState(100);
  const [rightBetErrorMessage, setRightBetErrorMessage] = useState({});
  const [rightBetButtonShow, setRightBetButtonShow] = useState(true);
  const [rightBetArray, setRightBetArray] = useState([]);
  const rightBetArrayRef = useRef([]);
  const [rightMainBetId, setRightMainBetId] = useState("");
  const [rightCashOutAmount, setRightCashOutAmount] = useState("");
  const [rightShowCashoutButton, setRightShowCashoutButton] = useState(false);
  const [rightIsCashingOut, setRightIsCashingOut] = useState(false);
  const rightBetPlacedRef = useRef(false);
  const [rightBetGameId, setRightBetGameId] = useState("");

  /** ===== Auto Bet / Auto Cashout ===== */
  const [leftAutoBet, setLeftAutoBet] = useState(false);
  const [rightAutoBet, setRightAutoBet] = useState(false);
  const [leftAutoCashout, setLeftAutoCashout] = useState(false);
  const [rightAutoCashout, setRightAutoCashout] = useState(false);
  const [leftAutoCashoutAt, setLeftAutoCashoutAt] = useState(1.1);
  const [rightAutoCashoutAt, setRightAutoCashoutAt] = useState(1.1);

  const leftAutoBetRef = useRef(false);
  const rightAutoBetRef = useRef(false);
  const leftAutoCashoutRef = useRef(false);
  const rightAutoCashoutRef = useRef(false);
  const leftAutoCashoutAtRef = useRef(1.1);
  const rightAutoCashoutAtRef = useRef(1.1);
  isAudioOmittedRef.current = isAudioOmitted;

  const isPostCrashScene = () => {
    const s = sceneRef.current;
    return s === "crashed" || s === "finished";
  };

  const tryAutoCashoutAtValue = (currentValue) => {
    const value = Number(currentValue);
    if (!(value + 0.0001 >= CASHOUT_MIN_MULTIPLIER)) return;
    for (const side of ["left", "right"]) {
      const autoOn =
        side === "left"
          ? leftAutoCashoutRef.current
          : rightAutoCashoutRef.current;
      const autoAt = parseFloat(
        side === "left"
          ? leftAutoCashoutAtRef.current
          : rightAutoCashoutAtRef.current
      );
      const placed =
        side === "left" ? leftBetPlacedRef.current : rightBetPlacedRef.current;
      const cashing =
        side === "left"
          ? leftIsCashingOutRef.current
          : rightIsCashingOutRef.current;
      if (!autoOn || !placed || cashing) continue;
      if (!(autoAt > 0) || value + 0.0001 < autoAt) continue;
      cashOutNowRef.current?.(side, autoAt);
    }
  };

  const showLostToastForUncashedBets = (evtId = roundIdRef.current) => {
    if (evtId && lostToastEvtRef.current === evtId) return;

    let lostAmount = 0;
    if (leftBetPlacedRef.current && !leftIsCashingOutRef.current) {
      lostAmount += Number(leftBetAmountRef.current) || 0;
    }
    if (rightBetPlacedRef.current && !rightIsCashingOutRef.current) {
      lostAmount += Number(rightBetAmountRef.current) || 0;
    }
    if (lostAmount <= 0) return;

    if (evtId) lostToastEvtRef.current = evtId;
    pendingLostToastEvtRef.current = null;
    showLostToast(lostAmount);
  };

  /** ===== Shared state ===== */
  const [roundId, setRoundId] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const isLoadGameRef = useRef(0);
  const lastCrashedEvtIdRef = useRef(null);
  const lastFinishedEvtIdRef = useRef(null);
  const closedHandledEvtIdRef = useRef(null);
  const lastFlightStartedEvtIdRef = useRef(null);
  const pendingTakeoffRef = useRef(null);
  const takeoffEvtIdRef = useRef(null);
  const introPhaseRef = useRef("show1");
  const lastCountdownResetEvtRef = useRef(null);
  const betPlacedToastEvtRef = useRef(null);
  //added by uk - each side has its own lock. Waiting for the left request let the round close before the right bet was sent.
  const leftPlacingRef = useRef(false);
  const rightPlacingRef = useRef(false);
  const lastLuckyPlayersEvtIdRef = useRef(null);
  const roundIdRef = useRef("");
  const sceneRef = useRef("loading");
  const closedResetRef = useRef(null);
  const crashHoldUntilRef = useRef(0);
  const nextRoundHoldMsRef = useRef(DEFAULT_NEXT_ROUND_HOLD_MS);
  const luckyStreamTimerRef = useRef(null);
  const luckyCashoutTimerRef = useRef(null);
  const luckyCashoutPlanRef = useRef(null);
  const luckyPendingQueueRef = useRef([]);
  const userPlacedBetIdsRef = useRef(new Set());
  const userPlacedBetIdsOrderRef = useRef([]);
  const sessionUser = useSelector((s) => s.userStore.data);

  const [userLuckyRecords, setUserLuckyRecords] = useState([]);
  const [liveBets, setLiveBets] = useState([]);
  const betsList = useMemo(
    () => [...userLuckyRecords, ...liveBets],
    [userLuckyRecords, liveBets]
  );
  const luckyPlayerCount = betsList.length;

  /** Track disconnection so we can reset on reconnect */
  const wasDisconnectedRef = useRef(false);

  const clearLuckyPlayersStream = () => {
    if (luckyStreamTimerRef.current) {
      clearTimeout(luckyStreamTimerRef.current);
      luckyStreamTimerRef.current = null;
    }
    if (luckyCashoutTimerRef.current) {
      clearInterval(luckyCashoutTimerRef.current);
      luckyCashoutTimerRef.current = null;
    }
  };

  const isInFlightScene = () =>
    sceneRef.current === "flight" ||
    sceneRef.current === "crashed" ||
    sceneRef.current === "finished";

  const getPreFlightStreamDelay = (remainingCount) => {
    const base = Math.max(
      20,
      Math.floor(PRE_FLIGHT_STREAM_WINDOW_MS / Math.max(remainingCount, 1))
    );
    return luckyRandomInt(Math.max(15, base - 10), base + 20);
  };

  const flushRemainingDummyBets = () => {
    const queue = luckyPendingQueueRef.current;
    if (!queue.length) return;
    luckyPendingQueueRef.current = [];
    setLiveBets((prev) => [...queue, ...prev]);
  };

  const stopDummyBetStream = () => {
    if (luckyStreamTimerRef.current) {
      clearTimeout(luckyStreamTimerRef.current);
      luckyStreamTimerRef.current = null;
    }
  };

  const finalizeDummyBetsBeforeFlight = () => {
    stopDummyBetStream();
    flushRemainingDummyBets();
  };

  const scheduleNextLiveBet = () => {
    if (isInFlightScene()) {
      luckyStreamTimerRef.current = null;
      return;
    }

    const queue = luckyPendingQueueRef.current;
    if (!queue.length) {
      luckyStreamTimerRef.current = null;
      return;
    }

    const batchSize = luckyRandomInt(2, 5);
    const batch = queue.splice(0, Math.min(batchSize, queue.length));
    setLiveBets((prev) => [...batch, ...prev]);

    if (!queue.length) {
      luckyStreamTimerRef.current = null;
      return;
    }

    const delay = getPreFlightStreamDelay(queue.length);
    luckyStreamTimerRef.current = setTimeout(scheduleNextLiveBet, delay);
  };

  const startLiveLuckyPlayersStream = () => {
    clearLuckyPlayersStream();
    luckyPendingQueueRef.current = createDummyBetQueue();
    userPlacedBetIdsRef.current = new Set();
    userPlacedBetIdsOrderRef.current = [];
    setUserLuckyRecords([]);
    setLiveBets([]);
    scheduleNextLiveBet();
  };

  const clearTakeoffPending = () => {
    pendingTakeoffRef.current = null;
    takeoffEvtIdRef.current = null;
    setTakeoffPending(false);
  };

  const startNextRoundCountdown = () => {
    if (sceneRef.current === "countdown") return;
    if (closedResetRef.current) {
      clearTimeout(closedResetRef.current);
      closedResetRef.current = null;
    }
    crashHoldUntilRef.current = 0;
    setLaunchCountdown(COUNTDOWN_BET_SECONDS);
    setFlightValue(0);
    setScene("countdown");
    sceneRef.current = "countdown";
    setIntroPhase("show1");
    introPhaseRef.current = "show1";
    setsmallTriger("");
    setballerState(Baller);
    setbatterState(Batsman1);
    setShowRoundGettingBets(true);
  };

  const playFlightAudio = () => {
    if (isAudioOmittedRef.current) {
      bgAudioRef.current?.play()?.catch(() => {});
    } else {
      bgAudioRef.current?.pause();
    }
  };

  const beginFlight = ({
    target,
    leftTime,
    runningResult,
    syncProgress = false,
    force = false,
    fromIntro = false
  }) => {
    const evtId = roundIdRef.current;
    const postCrashScenes = ["crashed", "finished"];

    if (sameEvtId(evtId, lastFinishedEvtIdRef.current)) return;
    if (sameEvtId(evtId, lastCrashedEvtIdRef.current)) return;
    if (sameEvtId(evtId, lastFlightStartedEvtIdRef.current)) return;
    if (!force && postCrashScenes.includes(sceneRef.current)) return;

    lastFlightStartedEvtIdRef.current = evtId;
    clearTakeoffPending();
    luckyCashoutPlanRef.current = null;
    finalizeDummyBetsBeforeFlight();

    const running = parseFloat(runningResult);
    const liveCap = lastServerRunningRef.current;
    const serverCap = Math.max(
      Number.isFinite(running) && running >= 1 ? running : 1,
      Number.isFinite(liveCap) && liveCap >= 1 ? liveCap : 1
    );
    if (crashKnownRef.current && Number.isFinite(maxFlightRef.current)) {
      lastServerRunningRef.current = Math.max(
        lastServerRunningRef.current || 1,
        maxFlightRef.current
      );
    } else {
      lastServerRunningRef.current = serverCap;
      maxFlightRef.current = serverCap;
    }

    skipStartHoldRef.current = false;
    capTsRef.current = performance.now();
    capIntervalRef.current = SERVER_TICK_MS;

    //added by uk - if the ball is already in the air, show the server number. Do not crawl up from 1.00.
    const startValue =
      Number.isFinite(running) && running >= 1 ? running : 1;
    const isLateJoin = startValue > 1.15;
    capFromRef.current = isLateJoin ? startValue : 1;
    flightValueRef.current = isLateJoin ? startValue : 1;
    counterRawRef.current = isLateJoin ? startValue : 1;
    setFlightValue(isLateJoin ? startValue : 1);
    lastStepRef.current = isLateJoin ? startValue : 1;
    startTsRef.current = performance.now();

    setShowRoundGettingBets(false);
    setScene("flight");
    sceneRef.current = "flight";
    setRunning(true);
    playFlightAudio();
  };

  const startTakeoffAfterBets = async ({
    target,
    leftTime,
    runningResult,
    syncProgress = false,
    force = false,
    replayAfterClose = false,
    payload: livePayload = null
  }) => {
    const evtId = roundIdRef.current;
    const evtStatus = livePayload?.evt_status ?? livePayload?.status;
    if (evtStatus === "CLOSED" && !replayAfterClose) return;
    if (sameEvtId(evtId, lastFinishedEvtIdRef.current)) return;
    if (sameEvtId(evtId, lastCrashedEvtIdRef.current)) return;
    const liveLeftTime = Number(livePayload?.left_time ?? leftTime);
    // A days-old Redis row reports start==1 and a 10-17x cap. Do not join it.
    if (Number.isFinite(liveLeftTime) && liveLeftTime > 300) return;
    if (!force && sameEvtId(evtId, lastFlightStartedEvtIdRef.current)) return;
    if (
      pendingTakeoffRef.current ||
      sameEvtId(takeoffEvtIdRef.current, evtId)
    )
      return;

    const cameFromCountdown = sceneRef.current === "countdown";
    const isLateJoin = !cameFromCountdown;

    if (isLateJoin) {
      beginFlight({
        target,
        leftTime,
        runningResult,
        syncProgress,
        force
      });
      return;
    }

    pendingTakeoffRef.current = {
      target,
      leftTime,
      runningResult,
      syncProgress,
      force,
      fromIntro: true,
      replayAfterClose
    };
    takeoffEvtIdRef.current = evtId;
    setTakeoffPending(true);
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
  };

  /** ===== Socket ===== */
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "cricketx"
  });
  //console.log("data: ", data);
  // ===== Socket reconnect handling =====
  useEffect(() => {
    if (!isConnected) {
      wasDisconnectedRef.current = true;
      // Pause the flight ticker while disconnected
      setRunning(false);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      return;
    }

    // Socket just came back online
    if (wasDisconnectedRef.current) {
      wasDisconnectedRef.current = false;
      //console.log("Socket reconnected \u2013 resetting CricketX state");

      // Reset the game to the loading state so server data drives the next scene
      setFlightValue(0);
      setScene("loading");
      sceneRef.current = "loading";
      isLoadGameRef.current = 0;
      lastCrashedEvtIdRef.current = null;
      lastFinishedEvtIdRef.current = null;
      //added by uk - the socket drop left this round marked as already flying, so the ball never started again.
      lastFlightStartedEvtIdRef.current = null;
      crashKnownRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConnected]);

  useEffect(() => {
    return () => {
      if (fetchBetAnimHideTimeoutRef.current) {
        clearTimeout(fetchBetAnimHideTimeoutRef.current);
        fetchBetAnimHideTimeoutRef.current = null;
      }
    };
  }, []);

  const rawInner = data?.data;
  const payload = rawInner?.data?.evt_id
    ? rawInner.data
    : rawInner?.evt_id
    ? rawInner
    : null;

  const payloadResult = data?.data?.result;

  /// result detail ///
  useEffect(() => {
    if (payloadResult !== null && payloadResult !== undefined) {
      setResultData(payloadResult);
    }
  }, [payloadResult]);
  /// result detail ///

  const userName = userInfo?.data?.uname || data?.user?.uname || "You";
  const payloadLuckyPlayers = rawInner?.data?.evt_id
    ? rawInner.lucky_players
    : data?.lucky_players;

  /** ===== Sync payload -> state ===== */

  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  useEffect(() => {
    if (!payload) return;

    updateUserData(data?.user);

    if (
      payload.next_round_delay != null ||
      payload.time_bet != null
    ) {
      nextRoundHoldMsRef.current = nextRoundHoldMsFromPayload(payload);
    }

    // Skip payloads if the evt_id is the same as the last finished round
    if (sameEvtId(payload.evt_id, lastFinishedEvtIdRef.current)) return;

    if (payload.evt_id) {
      setRoundId(payload.evt_id);
      roundIdRef.current = payload.evt_id;
    }

    const evtStatus = payload.evt_status ?? payload.status;
    if (payload.start == 0) {
      const incomingEvtId = payload.evt_id;
      const flyingThisRound =
        incomingEvtId &&
        lastFlightStartedEvtIdRef.current &&
        String(lastFlightStartedEvtIdRef.current) === String(incomingEvtId) &&
        (sceneRef.current === "flight" || sceneRef.current === "crashed");
      const takingOffThisRound =
        incomingEvtId &&
        takeoffEvtIdRef.current &&
        String(takeoffEvtIdRef.current) === String(incomingEvtId);
      // A late start==0 for the round that already took off would hide Cashout
      // for about a second and then bring it back. Ignore it.
      if (flyingThisRound || takingOffThisRound) {
        return;
      }
      const isNewCountdownRound =
        incomingEvtId && incomingEvtId !== lastCountdownResetEvtRef.current;

      // Next evt can open while this client is still flying/crashing the last one.
      // Close that flight against the old id so it cannot mark the new round finished.
      if (isNewCountdownRound && sceneRef.current === "flight") {
        const flyingEvtId = lastFlightStartedEvtIdRef.current;
        if (flyingEvtId && flyingEvtId !== incomingEvtId) {
          lastFinishedEvtIdRef.current = flyingEvtId;
          lastCrashedEvtIdRef.current = flyingEvtId;
          const result = maxFlightRef.current;
          if (result != null && result > 0) {
            setResultData((prev) => {
              const list = normalizeResultsList(prev);
              if (list.length > 0 && list[list.length - 1] === result) {
                return prev;
              }
              return [...list, result];
            });
          }
          pendingLostToastEvtRef.current = flyingEvtId;
          showLostToastForUncashedBets(flyingEvtId);
        }
        setRunning(false);
        if (rafRef.current) cancelAnimationFrame(rafRef.current);
      }

      lastFlightStartedEvtIdRef.current = null;
      clearTakeoffPending();
      if (closedHandledEvtIdRef.current === incomingEvtId) {
        closedHandledEvtIdRef.current = null;
      }
      if (sameEvtId(lastCrashedEvtIdRef.current, incomingEvtId)) {
        lastCrashedEvtIdRef.current = null;
      }
      crashKnownRef.current = false;
      lastServerRunningRef.current = 1;
      startTsRef.current = null;
      counterRawRef.current = null;
      capTsRef.current = 0;
      capFromRef.current = 1;
      capIntervalRef.current = SERVER_TICK_MS;
      if (closedResetRef.current) {
        clearTimeout(closedResetRef.current);
        closedResetRef.current = null;
      }

      // Stay on the OUT score for at least 4s, then Getting the Bets
      if (sceneRef.current === "crashed") {
        const holdUntil =
          crashHoldUntilRef.current ||
          performance.now() + MIN_CRASH_HOLD_MS;
        const remaining = holdUntil - performance.now();
        if (remaining > 50) {
          crashHoldUntilRef.current = holdUntil;
          if (closedResetRef.current) clearTimeout(closedResetRef.current);
          closedResetRef.current = setTimeout(() => {
            closedResetRef.current = null;
            startNextRoundCountdown();
          }, remaining);
        } else {
          startNextRoundCountdown();
        }
      } else if (sceneRef.current === "countdown" && isNewCountdownRound) {
        setLaunchCountdown(COUNTDOWN_BET_SECONDS);
        setIntroPhase("show1");
        introPhaseRef.current = "show1";
        setShowRoundGettingBets(true);
        clearTakeoffPending();
      } else if (
        sceneRef.current === "loading" ||
        sceneRef.current === "waiting" ||
        sceneRef.current === "finished" ||
        sceneRef.current === "flight"
      ) {
        startNextRoundCountdown();
      }

      if (isNewCountdownRound) {
        lastCountdownResetEvtRef.current = payload.evt_id;
        betPlacedToastEvtRef.current = null;
        lostToastEvtRef.current = null;

        setLeftBetButtonShow(true);
        setLeftShowCashoutButton(false);
        setLeftMainBetId("");
        leftMainBetIdRef.current = "";
        setLeftCashOutAmount("");
        leftBetPlacedRef.current = false;
        setLeftBetGameId("");
        leftBetGameIdRef.current = "";
        if (leftBetArrayRef.current.length === 0) setLeftBetErrorMessage({});

        setRightBetButtonShow(true);
        setRightShowCashoutButton(false);
        setRightMainBetId("");
        rightMainBetIdRef.current = "";
        setRightCashOutAmount("");
        rightBetPlacedRef.current = false;
        setRightBetGameId("");
        rightBetGameIdRef.current = "";
        if (rightBetArrayRef.current.length === 0) setRightBetErrorMessage({});
      }

      if (
        payload.evt_id &&
        payload.evt_id !== lastLuckyPlayersEvtIdRef.current
      ) {
        lastLuckyPlayersEvtIdRef.current = payload.evt_id;
        startLiveLuckyPlayersStream();
      }

      if (
        isNewCountdownRound &&
        leftAutoBetRef.current &&
        leftBetArrayRef.current.length === 0 &&
        !leftBetPlacedRef.current
      ) {
        handleBetClick("left");
      }
      if (
        isNewCountdownRound &&
        rightAutoBetRef.current &&
        rightBetArrayRef.current.length === 0 &&
        !rightBetPlacedRef.current
      ) {
        handleBetClick("right");
      }

      // The server refuses bets once start=1, so anything still queued has to go
      // out now, while the round is still open.
      if (isNewCountdownRound) {
        const flushLeft =
          leftBetArrayRef.current.length > 0 && !leftBetPlacedRef.current;
        const flushRight =
          rightBetArrayRef.current.length > 0 && !rightBetPlacedRef.current;
        if (flushLeft) {
          setLeftBetErrorMessage({ status: true, message: "Placing bet..." });
        }
        if (flushRight) {
          setRightBetErrorMessage({ status: true, message: "Placing bet..." });
        }
        if (flushLeft || flushRight) {
          placeAllBetsNowRef.current?.(flushLeft, flushRight);
        }
      }
    } else if (payload.start == 1 && evtStatus !== "CLOSED") {
      // The crash is not on the live feed — join from running_result.
      if (
        (sceneRef.current === "loading" || sceneRef.current === "waiting") &&
        lastFlightStartedEvtIdRef.current !== payload.evt_id
      ) {
        startTakeoffAfterBets({
          target: parseFloat(payload.running_result) || 1,
          runningResult: payload.running_result,
          leftTime: payload.left_time,
          syncProgress: true,
          payload
        });
      }

      if (
        !leftIsCashingOutRef.current &&
        (leftBetArrayRef.current.length > 0 || leftBetPlacedRef.current)
      ) {
        setLeftBetButtonShow(false);
      }
      if (
        !rightIsCashingOutRef.current &&
        (rightBetArrayRef.current.length > 0 || rightBetPlacedRef.current)
      ) {
        setRightBetButtonShow(false);
      }

      isLoadGameRef.current = 1;

      if (
        !leftIsCashingOutRef.current &&
        leftBetPlacedRef.current &&
        (leftMainBetIdRef.current || leftMainBetId)
      ) {
        setLeftShowCashoutButton(true);
      }
      if (
        !rightIsCashingOutRef.current &&
        rightBetPlacedRef.current &&
        (rightMainBetIdRef.current || rightMainBetId)
      ) {
        setRightShowCashoutButton(true);
      }
    }

    if (payload.start == 0) {
      isLoadGameRef.current = 0;
    }
  }, [payload]);

  useEffect(() => {
    if (!payload || payload.start != 1) return;
    const evtStatus = payload.evt_status ?? payload.status;
    if (evtStatus === "CLOSED") return;
    const srv = parseFloat(payload.running_result);
    if (!Number.isFinite(srv) || srv < 1) return;

    const nowTs = performance.now();
    const shown = Number.isFinite(counterRawRef.current)
      ? counterRawRef.current
      : 1;
    if (capTsRef.current > 0 && srv > lastServerRunningRef.current + 0.0001) {
      const measured = nowTs - capTsRef.current;
      if (measured >= 20 && measured <= 1500) {
        capIntervalRef.current = measured;
      }
    }
    capTsRef.current = nowTs;
    //added by uk - do not jump straight to the new server number.
    //added by uk - start from the number already on screen and climb up to it. Same filler as Aviator.
    capFromRef.current = Math.min(shown, srv);
    lastServerRunningRef.current = srv;
    maxFlightRef.current = srv;
    if (pendingTakeoffRef.current) {
      pendingTakeoffRef.current = {
        ...pendingTakeoffRef.current,
        runningResult: srv,
        target: srv
      };
    }
  }, [
    payload?.running_result,
    payload?.start,
    payload?.evt_status,
    payload?.evt_id
  ]);

  // Keep sceneRef in sync
  useEffect(() => {
    sceneRef.current = scene;
  }, [scene]);

  useEffect(() => {
    startLiveLuckyPlayersStream();
    return () => clearLuckyPlayersStream();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const placedOrder = userPlacedBetIdsOrderRef.current;
    if (
      !placedOrder.length ||
      !payloadLuckyPlayers ||
      typeof payloadLuckyPlayers !== "object"
    ) {
      return;
    }

    setUserLuckyRecords((prev) => {
      const next = placedOrder
        .map((betId) => {
          const existing = prev.find(
            (bet) => String(bet.betId) === String(betId)
          );
          if (existing?.locked) return existing;

          const entry = payloadLuckyPlayers[betId];
          if (entry) {
            const parsed = parseLuckyPlayerEntry(entry, {
              isUser: true,
              betId
            });
            if (parsed) {
              if (sceneRef.current !== "flight" || !parsed.locked) {
                return {
                  ...parsed,
                  rate: "--",
                  profit: "",
                  locked: false
                };
              }
              return parsed;
            }
          }
          return existing;
        })
        .filter(Boolean);

      return next.length ? next : prev;
    });
  }, [payloadLuckyPlayers]);

  useEffect(() => {
    flightValueRef.current = flightValue;
  }, [flightValue]);

  useEffect(() => {
    leftBetAmountRef.current = leftBetAmount;
  }, [leftBetAmount]);

  useEffect(() => {
    rightBetAmountRef.current = rightBetAmount;
  }, [rightBetAmount]);

  useEffect(() => {
    leftMainBetIdRef.current = leftMainBetId;
  }, [leftMainBetId]);

  useEffect(() => {
    rightMainBetIdRef.current = rightMainBetId;
  }, [rightMainBetId]);

  useEffect(() => {
    leftIsCashingOutRef.current = leftIsCashingOut;
  }, [leftIsCashingOut]);

  useEffect(() => {
    rightIsCashingOutRef.current = rightIsCashingOut;
  }, [rightIsCashingOut]);

  useEffect(() => {
    if (scene !== "flight" || flightValue < 1) {
      if (scene !== "flight") luckyCashoutPlanRef.current = null;
      return;
    }

    if (!luckyCashoutPlanRef.current) {
      setLiveBets((prev) => {
        if (prev.length > 0) {
          luckyCashoutPlanRef.current = buildLuckyCashoutPlan(
            LUCKY_PLAN_TARGET,
            prev.length
          );
        }
        return prev;
      });
      if (!luckyCashoutPlanRef.current) return;
    }

    const plan = luckyCashoutPlanRef.current;
    const pendingEvents = [];

    while (
      plan.nextEventIndex < plan.events.length &&
      flightValue + 0.0001 >= plan.events[plan.nextEventIndex].value
    ) {
      pendingEvents.push(plan.events[plan.nextEventIndex]);
      plan.nextEventIndex += 1;
    }

    if (!pendingEvents.length) return;

    setLiveBets((prev) =>
      applyLuckyCashoutEvents(prev, pendingEvents, plan.reserveCount)
    );
  }, [scene, flightValue]);

  /** ===== When status becomes CLOSED, trigger crash immediately (once per evt_id) ===== */
  useEffect(() => {
    const status = payload?.evt_status ?? payload?.status;
    const evtId = payload?.evt_id;
    if (
      status === "CLOSED" &&
      evtId &&
      closedHandledEvtIdRef.current !== evtId &&
      lastCrashedEvtIdRef.current !== evtId &&
      (sceneRef.current === "flight" ||
        sceneRef.current === "countdown" ||
        sceneRef.current === "loading" ||
        sceneRef.current === "waiting")
    ) {
      closedHandledEvtIdRef.current = evtId;
      nextRoundHoldMsRef.current = nextRoundHoldMsFromPayload(payload);
      const result = parseFloat(payload?.result);
      if (!Number.isFinite(result) || result <= 0) return; // wait until result is public

      crashKnownRef.current = true;
      maxFlightRef.current = result;
      lastServerRunningRef.current = Math.max(
        lastServerRunningRef.current || 1,
        result
      );

      const shown = Number.isFinite(counterRawRef.current)
        ? counterRawRef.current
        : 1;
      const alreadyShowingCrash = shown + 0.001 >= result;
      const stillOnCountdown = sceneRef.current === "countdown";
      const joiningClosedRound =
        sceneRef.current === "loading" || sceneRef.current === "waiting";

      if (joiningClosedRound) {
        lastCrashedEvtIdRef.current = evtId;
        counterRawRef.current = result;
        flightValueRef.current = result;
        lastStepRef.current = result;
        setFlightValue(result);
        triggerCrash();
      } else if (stillOnCountdown) {
        if (
          sameEvtId(evtId, lastFinishedEvtIdRef.current) ||
          sameEvtId(evtId, lastCrashedEvtIdRef.current)
        ) {
          return;
        }
        // Round closed during intro — still count 1.00 -> result. Never snap.
        startTakeoffAfterBets({
          target: result,
          runningResult: 1,
          force: true,
          replayAfterClose: true,
          payload
        });
      } else if (alreadyShowingCrash || sceneRef.current === "flight") {
        //added by uk - when the round closes, show the crash right away. Do not sit on the last number.
        lastCrashedEvtIdRef.current = evtId;
        counterRawRef.current = result;
        flightValueRef.current = result;
        lastStepRef.current = result;
        setFlightValue(result);
        triggerCrash();
      }

      if (closedResetRef.current) {
        clearTimeout(closedResetRef.current);
        closedResetRef.current = null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload?.evt_status, payload?.status, payload?.evt_id, payload?.result]);

  useEffect(() => {
    introPhaseRef.current = introPhase;
  }, [introPhase]);

  /** ===== Hold cheer girls + GETTING THE BETS; play game anim after takeoff ===== */
  useEffect(() => {
    if (scene !== "countdown") return;

    if (!takeoffPending) {
      setIntroPhase("show1");
      introPhaseRef.current = "show1";
      setShowRoundGettingBets(true);
      return;
    }

    setShowRoundGettingBets(false);

    let i = INTRO_STEPS.findIndex((s) => s.name === GAME_ANIM_START_STEP);
    if (i < 0) i = 0;

    const finishTakeoff = () => {
      const args = pendingTakeoffRef.current;
      pendingTakeoffRef.current = null;
      takeoffEvtIdRef.current = null;
      setTakeoffPending(false);
      if (args) beginFlight(args);
    };

    let timer;
    const runStep = () => {
      const step = INTRO_STEPS[i];
      setIntroPhase(step.name);
      timer = setTimeout(() => {
        if (step.name === "hit" || step.name === "ball-flight") {
          finishTakeoff();
          return;
        }
        i += 1;
        if (i >= INTRO_STEPS.length) {
          finishTakeoff();
          return;
        }
        runStep();
      }, step.ms);
    };

    runStep();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scene, takeoffPending]);

  /** ===== Intro sub-triggers ===== */
  useEffect(() => {
    if (introPhase === "show1") setsmallTriger("go");
    else if (introPhase === "show2") setsmallTriger("go2");
  }, [introPhase]);

  useEffect(() => {
    if (introPhase !== "throw") return;
    setballerState(Baller);
    const t1 = setTimeout(() => setballerState(Ballerthrowing), 200);
    const t2 = setTimeout(() => setballerState(Ballerthrowing2), 400);
    const t3 = setTimeout(() => setsmallTriger("move_ball"), 450);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [introPhase]);

  useEffect(() => {
    if (introPhase !== "hit") return;
    setbatterState(Batsman1);
    const t5 = setTimeout(() => setsmallTriger("move_ball_batter"), 200);
    const t1 = setTimeout(() => setbatterState(Batsman2), 200);
    const t2 = setTimeout(() => setbatterState(Batsman3), 400);
    const t3 = setTimeout(() => setbatterState(Batsman4), 600);
    const t4 = setTimeout(() => setbatterState(Batsman5), 800);
    const t6 = setTimeout(() => setsmallTriger("ball_hit"), 1100);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(t5);
      clearTimeout(t6);
    };
  }, [introPhase]);

  /** ===== Ball flame alternation during flight ===== */
  useEffect(() => {
    if (scene !== "flight") return;
    const interval = setInterval(() => setCount((prev) => prev + 1), 300);
    return () => clearInterval(interval);
  }, [scene]);

  useEffect(() => {
    if (scene !== "flight") return;
    setballFlame(count % 2 === 0 ? Ballbgfiremoving : Ballflame);
  }, [scene, count]);

  /** ===== Countdown ===== */
  useEffect(() => {
    if (scene !== "countdown") return;

    // Take off the moment the server does, even if the local countdown has time
    // left. Short rounds are over in a second and cannot wait for it.
    if (payload?.start == 1) {
      // Don't replay a round that already finished
      if (sameEvtId(payload?.evt_id, lastFinishedEvtIdRef.current)) return;
      if (sameEvtId(payload?.evt_id, lastCrashedEvtIdRef.current)) return;
      const evtStatus = payload?.evt_status ?? payload?.status;
      if (evtStatus === "CLOSED") return;
      if (sameEvtId(lastFlightStartedEvtIdRef.current, payload?.evt_id))
        return;

      startTakeoffAfterBets({
        target: parseFloat(payload?.running_result) || 1,
        runningResult: payload?.running_result,
        syncProgress: true,
        payload
      });
      return;
    }

    if (launchCountdown <= 0) return; // wait for the server to start the round

    const t = setTimeout(() => setLaunchCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [scene, launchCountdown, payload?.start, payload?.running_result]);

  /** ===== Flight ticker (only during "flight") ===== */
  useEffect(() => {
    if (scene !== "flight" || !running) return;

    let countingStarted = false;

    const tick = (now) => {
      const evtId = roundIdRef.current;
      if (sameEvtId(evtId, lastFinishedEvtIdRef.current)) {
        setRunning(false);
        return;
      }

      const target = maxFlightRef.current;

      if (target == null || target <= 0) {
        rafRef.current = requestAnimationFrame(tick);
        return;
      }

      if (!countingStarted) {
        countingStarted = true;
        if (startTsRef.current == null) startTsRef.current = now;
        if (!(lastStepRef.current >= 1)) lastStepRef.current = 1;
        if (!(counterRawRef.current >= 1)) counterRawRef.current = 1;
      }

      const cap = lastServerRunningRef.current;
      const safeCap = Number.isFinite(cap) && cap >= 1 ? cap : 1;

      const from = Math.max(
        1,
        Number.isFinite(capFromRef.current) ? capFromRef.current : safeCap
      );
      const sinceCap = Math.max(0, now - (capTsRef.current || now));
      //added by uk - filler. Walk one cent at a time up to the server number.
      //added by uk - 200ms per cent until 1.10, then 91ms. Same speed as Aviator.
      const cents = Math.max(0, Math.round((safeCap - from) * 100));
      const stepMs = safeCap <= 1.1 ? 200 : 91;
      const catchWindowMs = Math.max(40, cents * stepMs);
      const progress = Math.min(1, sinceCap / catchWindowMs);
      let raw = from + (safeCap - from) * progress;
      raw = Math.min(safeCap, raw);
      const prevRaw = counterRawRef.current;
      if (Number.isFinite(prevRaw) && prevRaw > raw) raw = Math.min(prevRaw, safeCap);

      counterRawRef.current = raw;
      const next = Math.max(1, Math.floor(raw * 100) / 100);
      flightValueRef.current = next;

      tryAutoCashoutAtValue(Math.min(next, safeCap));

      // Hold at running_result until CLOSED publishes result. Do not crash on the cap.
      if (crashKnownRef.current && next + 0.001 >= (target || safeCap)) {
        lastStepRef.current = target || safeCap;
        flightValueRef.current = target || safeCap;
        setFlightValue(target || safeCap);
        triggerCrash();
        return;
      }

      if (next !== lastStepRef.current) {
        lastStepRef.current = next;
        setFlightValue(next);
      }
      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scene, running]);

  /** ===== Crash  ===== */
  const triggerCrash = () => {
    if (sceneRef.current === "crashed") return;

    setRunning(false);
    if (rafRef.current) cancelAnimationFrame(rafRef.current);

    const crashedEvtId =
      lastFlightStartedEvtIdRef.current || roundIdRef.current;
    if (crashedEvtId) {
      lastFinishedEvtIdRef.current = crashedEvtId;
      lastCrashedEvtIdRef.current = crashedEvtId;
    }

    const result = maxFlightRef.current;
    if (result != null && result > 0) {
      setResultData((prev) => {
        const list = normalizeResultsList(prev);
        if (list.length > 0 && list[list.length - 1] === result) return prev;
        return [...list, result];
      });
    }

    setScene("crashed");
    sceneRef.current = "crashed";
    setShowRoundGettingBets(false);
    clearTakeoffPending();

    tryAutoCashoutAtValue(result);
    pendingLostToastEvtRef.current = crashedEvtId;
    showLostToastForUncashedBets(crashedEvtId);

    if (closedResetRef.current) {
      clearTimeout(closedResetRef.current);
      closedResetRef.current = null;
    }

    setLeftBetButtonShow(true);
    setRightBetButtonShow(true);
    setLeftShowCashoutButton(false);
    setRightShowCashoutButton(false);

    const holdMs = Math.max(
      MIN_CRASH_HOLD_MS,
      nextRoundHoldMsRef.current || DEFAULT_NEXT_ROUND_HOLD_MS
    );
    crashHoldUntilRef.current = performance.now() + holdMs;
    closedResetRef.current = setTimeout(() => {
      closedResetRef.current = null;
      startNextRoundCountdown();
    }, holdMs);
  };

  /** ===== Sound toggle ===== */
  const toggleSound = (e) => {
    const on = e.target.checked;
    setSoundEnabled(on);
    if (on) {
      setIsAudioOmitted(true);
      bgAudioRef.current?.play();
    } else {
      setIsAudioOmitted(false);
      bgAudioRef.current?.pause();
    }
  };

  /** ===== Handle Bet Click ===== */
  const handleBetClick = (side) => {
    const betAmount = side === "left" ? leftBetAmount : rightBetAmount;
    const bettype = "b";
    const setBetErrorMessage =
      side === "left" ? setLeftBetErrorMessage : setRightBetErrorMessage;
    const betArrayRef = side === "left" ? leftBetArrayRef : rightBetArrayRef;
    const setBetArray = side === "left" ? setLeftBetArray : setRightBetArray;

    if (!betAmount || betAmount <= 0) return;

    const liveOdds = Number(payload?.b1);
    const betObj = {
      amount: Number(betAmount),
      profit: 0,
      catmid: payload?.evt_id || roundIdRef.current || roundId,
      round: payload?.evt_id || roundIdRef.current || roundId,
      odds: Number.isFinite(liveOdds) && liveOdds > 0 ? liveOdds : 1.95,
      teamname: "cricketx",
      bettype: bettype,
      marketVal: 1,
      game_type: 7,
      market_type: "m",
      game_name: "cricketx"
    };

    const newBet = { ...betObj, is_bet: false };
    betArrayRef.current = [...betArrayRef.current, newBet];
    setBetArray([...betArrayRef.current]);

    // The server refuses bets once the round starts, so send it while it is open.
    if (payload?.start == 0) {
      setBetErrorMessage({
        status: true,
        message: "Placing bet..."
      });
      placeAllBetsNowRef.current?.(side === "left", side === "right");
    } else {
      setBetErrorMessage({
        status: true,
        message: "Bet queued for next round"
      });
    }
  };

  /** ===== Place all queued bets in a single API call ===== */
  const placeAllBetsNow = async (wantLeft, wantRight) => {
    //added by uk - send the right bet now. Do not wait for the left request, or the round is already closed.
    const hasLeft = !!wantLeft && !leftPlacingRef.current;
    const hasRight = !!wantRight && !rightPlacingRef.current;
    if (!hasLeft && !hasRight) return;

    const placedEvtId = roundIdRef.current;
    const combinedBetArray = [];
    let leftBetObj = null;
    let rightBetObj = null;
    let leftBetsSnapshot = [];
    let rightBetsSnapshot = [];

    if (hasLeft) {
      leftBetsSnapshot = [...leftBetArrayRef.current];
      leftBetArrayRef.current = [];
      setLeftBetArray([]);
      for (const bet of leftBetsSnapshot) {
        if (!bet.is_bet) {
          bet.is_bet = true;
          bet.catmid = placedEvtId || bet.catmid;
          bet.round = placedEvtId || bet.round;
          leftBetObj = bet;
          combinedBetArray.push({
            bet_type: bet.game_type,
            bet_amount: bet.amount,
            section_no: 0
          });
        }
      }
    }

    if (hasRight) {
      rightBetsSnapshot = [...rightBetArrayRef.current];
      rightBetArrayRef.current = [];
      setRightBetArray([]);
      for (const bet of rightBetsSnapshot) {
        if (!bet.is_bet) {
          bet.is_bet = true;
          bet.catmid = placedEvtId || bet.catmid;
          bet.round = placedEvtId || bet.round;
          rightBetObj = bet;
          combinedBetArray.push({
            bet_type: bet.game_type,
            bet_amount: bet.amount,
            section_no: 1
          });
        }
      }
    }

    if (combinedBetArray.length === 0) return;
    if (hasLeft) leftPlacingRef.current = true;
    if (hasRight) rightPlacingRef.current = true;

    const restoreQueuedBets = () => {
      if (hasLeft && leftBetsSnapshot.length) {
        const restored = leftBetsSnapshot.map((bet) => ({
          ...bet,
          is_bet: false,
          catmid: placedEvtId || bet.catmid,
          round: placedEvtId || bet.round
        }));
        leftBetArrayRef.current = restored;
        setLeftBetArray(restored);
      }
      if (hasRight && rightBetsSnapshot.length) {
        const restored = rightBetsSnapshot.map((bet) => ({
          ...bet,
          is_bet: false,
          catmid: placedEvtId || bet.catmid,
          round: placedEvtId || bet.round
        }));
        rightBetArrayRef.current = restored;
        setRightBetArray(restored);
      }
    };

    const baseBet = leftBetObj || rightBetObj;
    const liveOdds = Number(baseBet?.odds);
    const requestBody = {
      ...baseBet,
      amount: Number(baseBet?.amount),
      teamname: "cricketx",
      bettype: baseBet?.bettype || "b",
      market_type: "m",
      game_name: "cricketx",
      odds: Number.isFinite(liveOdds) && liveOdds > 0 ? liveOdds : 1.95,
      catmid: roundIdRef.current || baseBet.catmid,
      round: roundIdRef.current || baseBet.round,
      bet_array: combinedBetArray
    };

    if (fetchBetAnimHideTimeoutRef.current) {
      clearTimeout(fetchBetAnimHideTimeoutRef.current);
      fetchBetAnimHideTimeoutRef.current = null;
    }
    fetchBetAnimStartRef.current = Date.now();
    setFetchBetAnimKey((k) => k + 1);
    setIsPlacingBets(true);
    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        requestBody
      );

      if (response.data?.status != null) {
        if (response.data.status) {
          const returnBets = response.data?.data?.return_bets;
          const betsArray = Array.isArray(returnBets)
            ? returnBets
            : returnBets?.bet_id
            ? [returnBets]
            : [];

          let anyBetConfirmed = false;
          if (hasLeft && hasRight) {
            if (betsArray[0]?.bet_id) {
              leftMainBetIdRef.current = betsArray[0].bet_id;
              leftBetGameIdRef.current = roundIdRef.current || roundId;
              setLeftMainBetId(betsArray[0].bet_id);
              setLeftBetGameId(roundIdRef.current || roundId);
              leftBetPlacedRef.current = true;
              setLeftShowCashoutButton(true);
              setLeftBetButtonShow(false);
              anyBetConfirmed = true;
            }
            if (betsArray[1]?.bet_id) {
              rightMainBetIdRef.current = betsArray[1].bet_id;
              rightBetGameIdRef.current = roundIdRef.current || roundId;
              setRightMainBetId(betsArray[1].bet_id);
              setRightBetGameId(roundIdRef.current || roundId);
              rightBetPlacedRef.current = true;
              setRightShowCashoutButton(true);
              setRightBetButtonShow(false);
              anyBetConfirmed = true;
            }
          } else if (hasLeft) {
            if (betsArray[0]?.bet_id) {
              leftMainBetIdRef.current = betsArray[0].bet_id;
              leftBetGameIdRef.current = roundIdRef.current || roundId;
              setLeftMainBetId(betsArray[0].bet_id);
              setLeftBetGameId(roundIdRef.current || roundId);
              leftBetPlacedRef.current = true;
              setLeftShowCashoutButton(true);
              setLeftBetButtonShow(false);
              anyBetConfirmed = true;
            }
          } else if (hasRight) {
            if (betsArray[0]?.bet_id) {
              rightMainBetIdRef.current = betsArray[0].bet_id;
              rightBetGameIdRef.current = roundIdRef.current || roundId;
              setRightMainBetId(betsArray[0].bet_id);
              setRightBetGameId(roundIdRef.current || roundId);
              rightBetPlacedRef.current = true;
              setRightShowCashoutButton(true);
              setRightBetButtonShow(false);
              anyBetConfirmed = true;
            }
          }

          const placedAmounts = [];
          if (hasLeft && hasRight) {
            if (leftBetObj) placedAmounts.push(leftBetObj.amount);
            if (rightBetObj) placedAmounts.push(rightBetObj.amount);
          } else if (hasLeft && leftBetObj) {
            placedAmounts.push(leftBetObj.amount);
          } else if (hasRight && rightBetObj) {
            placedAmounts.push(rightBetObj.amount);
          }

          const userRecords = buildUserRecordsFromReturnBets(
            betsArray,
            placedAmounts,
            userName
          );
          if (userRecords.length) {
            userPlacedBetIdsOrderRef.current = userRecords.map(
              (record) => record.betId
            );
            userPlacedBetIdsRef.current = new Set(
              userPlacedBetIdsOrderRef.current.map(String)
            );
            setUserLuckyRecords(userRecords);
          }

          if (
            anyBetConfirmed &&
            roundIdRef.current &&
            betPlacedToastEvtRef.current !== roundIdRef.current
          ) {
            betPlacedToastEvtRef.current = roundIdRef.current;
            showBetPlacedToast();
            if (hasLeft) setLeftBetErrorMessage({});
            if (hasRight) setRightBetErrorMessage({});
          }
          if (anyBetConfirmed) {
            const roundAlreadyOver =
              pendingLostToastEvtRef.current === placedEvtId ||
              lastFinishedEvtIdRef.current === placedEvtId;
            if (roundAlreadyOver) {
              showLostToastForUncashedBets(placedEvtId);
            } else {
              tryAutoCashoutAtValue(flightValueRef.current);
            }
          } else {
            restoreQueuedBets();
          }
        } else {
          restoreQueuedBets();
          const msg = { status: false, message: response.data.message };
          if (hasLeft) setLeftBetErrorMessage(msg);
          if (hasRight) setRightBetErrorMessage(msg);
        }
      } else {
        restoreQueuedBets();
      }
    } catch (error) {
      restoreQueuedBets();
      const errMsg = {
        status: false,
        message: error.response?.data?.message || "Bet placement failed"
      };
      if (hasLeft) setLeftBetErrorMessage(errMsg);
      if (hasRight) setRightBetErrorMessage(errMsg);
    } finally {
      if (hasLeft) leftPlacingRef.current = false;
      if (hasRight) rightPlacingRef.current = false;
      const elapsed = Date.now() - fetchBetAnimStartRef.current;
      const waitMs = Math.max(0, FETCH_BET_ANIM_MS - elapsed);
      fetchBetAnimHideTimeoutRef.current = setTimeout(() => {
        setIsPlacingBets(false);
        fetchBetAnimHideTimeoutRef.current = null;
      }, waitMs);
    }
  };
  placeAllBetsNowRef.current = placeAllBetsNow;

  /** ===== Cancel queued bet ===== */
  const cancelBet = (side) => {
    if (side === "left") {
      leftBetArrayRef.current = [];
      setLeftBetArray([]);
      setLeftBetErrorMessage({ status: false, message: "Bet cancelled" });
    } else {
      rightBetArrayRef.current = [];
      setRightBetArray([]);
      setRightBetErrorMessage({ status: false, message: "Bet cancelled" });
    }
  };

  /** ===== Cashout handler ===== */
  const cashOutNow = async (side, multiplierOverride) => {
    const isCashingOutRef =
      side === "left" ? leftIsCashingOutRef : rightIsCashingOutRef;
    const mainBetIdRef = side === "left" ? leftMainBetIdRef : rightMainBetIdRef;
    const betGameIdRef = side === "left" ? leftBetGameIdRef : rightBetGameIdRef;
    const mainBetId =
      mainBetIdRef.current ||
      (side === "left" ? leftMainBetId : rightMainBetId);
    const betAmount = side === "left" ? leftBetAmount : rightBetAmount;
    const setIsCashingOut =
      side === "left" ? setLeftIsCashingOut : setRightIsCashingOut;
    const setShowCashoutButton =
      side === "left" ? setLeftShowCashoutButton : setRightShowCashoutButton;
    const setMainBetId = side === "left" ? setLeftMainBetId : setRightMainBetId;
    const betPlacedRef = side === "left" ? leftBetPlacedRef : rightBetPlacedRef;
    const setBetErrorMessage =
      side === "left" ? setLeftBetErrorMessage : setRightBetErrorMessage;
    const setCashOutAmount =
      side === "left" ? setLeftCashOutAmount : setRightCashOutAmount;
    const setBetButtonShow =
      side === "left" ? setLeftBetButtonShow : setRightBetButtonShow;
    const betArrayRef = side === "left" ? leftBetArrayRef : rightBetArrayRef;
    const setBetArray = side === "left" ? setLeftBetArray : setRightBetArray;

    if (!mainBetId || isCashingOutRef.current) return;

    const rawMultiplier =
      multiplierOverride != null && Number(multiplierOverride) > 0
        ? Number(multiplierOverride)
        : Number(flightValueRef.current);
    if (!(rawMultiplier + 0.0001 >= CASHOUT_MIN_MULTIPLIER)) return;
    const incrementor = rawMultiplier.toFixed(2);
    const gameId = betGameIdRef.current || roundIdRef.current || roundId;
    const cashedBetId = mainBetId;

    setIsCashingOut(true);
    isCashingOutRef.current = true;
    setShowCashoutButton(false);
    setBetButtonShow(true);
    setCashOutAmount("");

    try {
      const response = await axiosInstance.post("/casino/cash-out", {
        game_id: gameId,
        bet_id: cashedBetId,
        gametype: "cricketx",
        win_multiplier: incrementor
      });

      const result = response.data;

      if (result.isSuccess && result.error === 0) {
        const wonAmount =
          result.data?.cash_out_amount ?? result.cash_out_amount;
        if (wonAmount != null && wonAmount !== "") {
          showWinToast(wonAmount);
        }

        setBetErrorMessage({});

        setShowCashoutButton(false);
        setBetButtonShow(true);
        mainBetIdRef.current = "";
        setMainBetId("");
        setCashOutAmount("");
        betPlacedRef.current = false;

        betArrayRef.current = [];
        setBetArray([]);

        const cashedAmount = parseFloat(betAmount);
        setUserLuckyRecords((prev) =>
          prev.map((bet) => {
            if (String(bet.betId) !== String(cashedBetId) || bet.locked) {
              return bet;
            }
            const amount = bet.amountRaw || cashedAmount;
            return {
              ...bet,
              rate: incrementor,
              profit: calcLuckyPlayerProfit(incrementor, amount),
              locked: true
            };
          })
        );
      } else {
        const crashAt = Number(maxFlightRef.current);
        const requested = parseFloat(incrementor);
        const cashedAtOrBelowCrash =
          Number.isFinite(crashAt) &&
          Number.isFinite(requested) &&
          requested <= crashAt + 0.001;
        if (isPostCrashScene() && !cashedAtOrBelowCrash) {
          isCashingOutRef.current = false;
          showLostToastForUncashedBets();
        }
        const stillFlying = sceneRef.current === "flight";
        setShowCashoutButton(stillFlying);
        if (stillFlying) setBetButtonShow(false);
        setBetErrorMessage({
          status: false,
          message: result.message || "Cashout failed"
        });
      }
    } catch (error) {
      console.error("Cashout error:", error);
      const crashAt = Number(maxFlightRef.current);
      const requested = parseFloat(incrementor);
      const cashedAtOrBelowCrash =
        Number.isFinite(crashAt) &&
        Number.isFinite(requested) &&
        requested <= crashAt + 0.001;
      if (isPostCrashScene() && !cashedAtOrBelowCrash) {
        isCashingOutRef.current = false;
        showLostToastForUncashedBets();
      }
      const stillFlying = sceneRef.current === "flight";
      setShowCashoutButton(stillFlying);
      if (stillFlying) setBetButtonShow(false);
      setBetErrorMessage({
        status: false,
        message: error.response?.data?.message || "Cashout request failed"
      });
    } finally {
      isCashingOutRef.current = false;
      setIsCashingOut(false);
    }
  };
  cashOutNowRef.current = cashOutNow;

  /** ===== Loading screen timer ===== */
  useEffect(() => {
    const t = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(t);
  }, []);

  /** ===== Re-sync queued bets on crash ===== */
  useEffect(() => {
    if (scene === "crashed") {
      setLeftBetArray([...leftBetArrayRef.current]);
      setRightBetArray([...rightBetArrayRef.current]);
    }
  }, [scene]);

  /** ===== Show cashout button when bet is confirmed and flight is active ===== */
  useEffect(() => {
    if (scene !== "flight") return;
    if (
      !leftIsCashingOutRef.current &&
      leftBetPlacedRef.current &&
      (leftMainBetId || leftMainBetIdRef.current)
    ) {
      setLeftShowCashoutButton(true);
    }
    if (
      !rightIsCashingOutRef.current &&
      rightBetPlacedRef.current &&
      (rightMainBetId || rightMainBetIdRef.current)
    ) {
      setRightShowCashoutButton(true);
    }
  }, [scene, leftMainBetId, rightMainBetId]);

  /** ===== Auto Cashout ===== */
  useEffect(() => {
    if (scene !== "flight" || flightValue < CASHOUT_MIN_MULTIPLIER) return;
    tryAutoCashoutAtValue(
      Math.min(flightValue, lastServerRunningRef.current || flightValue)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    flightValue,
    scene,
    leftShowCashoutButton,
    rightShowCashoutButton,
    leftIsCashingOut,
    rightIsCashingOut
  ]);

  /** ===== Update cashout amount during flight ===== */
  useEffect(() => {
    if (scene === "flight" && flightValue > 0) {
      if (leftShowCashoutButton && leftBetAmount > 0) {
        setLeftCashOutAmount(
          (parseFloat(leftBetAmount) * flightValue).toFixed(2)
        );
      }
      if (rightShowCashoutButton && rightBetAmount > 0) {
        setRightCashOutAmount(
          (parseFloat(rightBetAmount) * flightValue).toFixed(2)
        );
      }
    }
  }, [
    flightValue,
    scene,
    leftShowCashoutButton,
    rightShowCashoutButton,
    leftBetAmount,
    rightBetAmount
  ]);

  /** Convenience flags */
  const showTimer = scene === "flight" || scene === "crashed";
  const hasValidPayload = payload != null && !!payload?.evt_id;

  useEffect(() => {
    document.documentElement.classList.add("roulette-bg-black", "h-100");
    return () => {
      document.documentElement.classList.remove("roulette-bg-black", "h-100");
    };
  }, []);

  /** ===== Reusable Bet Panel render function ===== */
  const renderBetPanel = (side) => {
    const isLeft = side === "left";
    const betAmount = isLeft ? leftBetAmount : rightBetAmount;
    const setBetAmount = isLeft ? setLeftBetAmount : setRightBetAmount;
    const betArray = isLeft ? leftBetArray : rightBetArray;
    const showCashoutButton = isLeft
      ? leftShowCashoutButton
      : rightShowCashoutButton;
    const betButtonShow = isLeft ? leftBetButtonShow : rightBetButtonShow;
    const mainBetId = isLeft ? leftMainBetId : rightMainBetId;
    const cashOutAmount = isLeft ? leftCashOutAmount : rightCashOutAmount;
    const isCashingOut = isLeft ? leftIsCashingOut : rightIsCashingOut;
    const betErrorMessageObj = isLeft
      ? leftBetErrorMessage
      : rightBetErrorMessage;
    const autoBet = isLeft ? leftAutoBet : rightAutoBet;
    const autoCashout = isLeft ? leftAutoCashout : rightAutoCashout;
    const autoCashoutAt = isLeft ? leftAutoCashoutAt : rightAutoCashoutAt;
    const setAutoBetState = (val) => {
      if (isLeft) {
        setLeftAutoBet(val);
        leftAutoBetRef.current = val;
      } else {
        setRightAutoBet(val);
        rightAutoBetRef.current = val;
      }
    };
    const setAutoCashoutState = (val) => {
      if (isLeft) {
        setLeftAutoCashout(val);
        leftAutoCashoutRef.current = val;
      } else {
        setRightAutoCashout(val);
        rightAutoCashoutRef.current = val;
      }
    };
    const setAutoCashoutAtState = (val) => {
      if (isLeft) {
        setLeftAutoCashoutAt(val);
        leftAutoCashoutAtRef.current = val;
      } else {
        setRightAutoCashoutAt(val);
        rightAutoCashoutAtRef.current = val;
      }
    };
    return (
      <div className="cricx-bet-box">
        {/* Top row: −  amount  +  action-button */}
        <div className="cricx-top-row">
          <button
            className="cricx-btn-round"
            type="button"
            onClick={() => setBetAmount((v) => Math.max(1, v - 100))}
          >
            −
          </button>
          <input
            type="number"
            maxLength="6"
            className="cricx-amount-input"
            value={betAmount}
            onInput={(e) => {
              const val = e.target.value
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1");
              setBetAmount(val === "" ? "" : Math.max(1, parseInt(val) || 0));
            }}
          />
          <button
            className="cricx-btn-round"
            type="button"
            onClick={() => setBetAmount((v) => v + 100)}
          >
            +
          </button>

          {/* Bet / Cancel / Cashout — inline in top row */}
          {(() => {
            const showCancel = betArray.length > 0 && !showCashoutButton;
            const showCashout =
              showCashoutButton && scene === "flight" && !isCashingOut;
            const showBet =
              !showCancel && !showCashout && !(showCashoutButton && takeoffPending);
            return (
              <>
                {showBet && (
                  <button
                    type="button"
                    className="cricx-action-button btn btn-success"
                    onClick={() => handleBetClick(side)}
                    disabled={!betButtonShow || !hasValidPayload}
                  >
                    {scene === "countdown" && hasValidPayload
                      ? "Place"
                      : "Next"}
                  </button>
                )}
                {showCancel && (
                  <button
                    type="button"
                    className="cricx-action-button btn btn-info"
                    onClick={() => cancelBet(side)}
                  >
                    Cancel
                  </button>
                )}
                {showCashout && (
                  <button
                    type="button"
                    className="cricx-action-button btn btn-warning"
                    onClick={() => cashOutNow(side)}
                    disabled={isCashingOut}
                  >
                    <input
                      type="hidden"
                      name={`${side}_bet_id`}
                      value={mainBetId}
                    />
                    Cashout{cashOutAmount ? ` ${cashOutAmount}` : ""}
                  </button>
                )}
              </>
            );
          })()}
        </div>

        {/* Quick-amount preset buttons */}
        <div className="cricx-quick-buttons">
          {[2000, 5000].map((amt) => (
            <button key={amt} type="button" onClick={() => setBetAmount(amt)}>
              {amt}
            </button>
          ))}
          {[1000, 5000].map((amt) => (
            <button
              key={`plus-${amt}`}
              type="button"
              onClick={() => setBetAmount((v) => v + amt)}
            >
              +{amt}
            </button>
          ))}
        </div>

        {/* Error/Success message */}
        {betErrorMessageObj.message && (
          <div
            className={`alert ${
              betErrorMessageObj.status ? "alert-success" : "alert-danger"
            } m-0 p-1`}
            style={{ fontSize: "11px" }}
          >
            {betErrorMessageObj.message}
          </div>
        )}

        {/* Auto section */}
        <div className="cricx-options-row">
          <div
            style={{
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
              marginBottom: "6px"
            }}
          >
            Auto
          </div>
          <div className="cricx-auto-container">
            <div className="cricx-switch-group">
              <label className="cricx-switch-label">
                <input
                  type="checkbox"
                  checked={autoBet}
                  onChange={(e) => setAutoBetState(e.target.checked)}
                />
                <span className="cricx-switch"></span>
                BET
              </label>
              <label className="cricx-switch-label">
                <input
                  type="checkbox"
                  checked={autoCashout}
                  onChange={(e) => setAutoCashoutState(e.target.checked)}
                />
                <span className="cricx-switch"></span>
                Cashout
              </label>
            </div>
            <div
              className="cricx-multiplier-control"
              style={{ display: autoCashout ? "flex" : "none" }}
            >
              <button
                className="cricx-btn-round"
                type="button"
                onClick={() =>
                  setAutoCashoutAtState(
                    Math.max(1.1, +(autoCashoutAt - 0.02).toFixed(2))
                  )
                }
              >
                −
              </button>
              <input
                type="number"
                min="1.10"
                max="100"
                step="0.02"
                className="cricx-multiplier-input"
                value={autoCashoutAt}
                onChange={(e) =>
                  setAutoCashoutAtState(parseFloat(e.target.value) || 1.1)
                }
              />
              <button
                className="cricx-btn-round"
                type="button"
                onClick={() =>
                  setAutoCashoutAtState(+(autoCashoutAt + 0.02).toFixed(2))
                }
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="roulette-scope roulette-bg-black h-100">
        <ClientLayoutWithOutHeader>
          {/* Loading Screen */}
          {isLoading && (
            <div
              style={{
                background: "#000",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <img
                src="/assets/images/tpstudio/cricketxstat.webp"
                alt="Loading"
                style={{ animation: "cricketx-smooth-blink 2s infinite" }}
              />
            </div>
          )}

          <style>
            {`
            /* All rules scoped under .cricketx-scope — does not affect other routes */
            @keyframes cricketx-smooth-blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.3; }
            }
            @keyframes cricketx-fill-progress {
              to { width: 100%; }
            }
            .cricketx-scope .lobby-ctn .title-section .exposure-search-ctn .exposure-balance-ctn,
            .cricketx-scope .exposure-balance-ctn {
              padding: 2px !important;
            }
            .cricketx-scope .loading-game {
              position: absolute;
              inset: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 10;
            }
            .cricketx-scope .waiting-text {
              font-family: 'Roboto Condensed', sans-serif;
              font-size: 20px;
              margin-top: 15px;
              color: white;
              text-shadow: 0 0 10px rgba(0,0,0,0.5);
            }
            .cricketx-scope .line-loader {
              width: 150px;
              height: 4px;
              background: #333;
              margin-top: 10px;
              border-radius: 2px;
              overflow: hidden;
            }
            .cricketx-scope .fill-line {
              height: 100%;
              background: #E50539;
              width: 0%;
              animation: cricketx-fill-progress 5s linear forwards;
            }
            .cricketx-scope .player-scope .table-player .player {
              width: 210px !important;
            }
            .cricketx-scope .player-scope .table-player {
              gap: 9px !important;
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              height: auto !important;
              min-height: auto !important;
            }
            .cricketx-scope .player-scope .table-player .player-dt {
              display: flex !important;
              flex-direction: column;
              align-items: center !important;
              max-width: none;
              width: auto;
              color: #d7bc7b !important;
              font-size: 12px;
              font-weight: 700;
            }
            @media (min-width:992px){
              .cricketx-scope .cards-layout.blackjack {
                min-height: 240px;
              }
              .cricketx-scope .volume-wrapper {
                margin-top: -30px;
              }
            }
            @media (max-width: 576px) {
              .cricketx-scope .cards-layout.blackjack {
                min-height: 120px !important;
                width: 100% !important;
                padding: 0 !important;
              }
              .cricketx-scope .scroll-containeraviator img {
                width: 100% !important;
                height: auto !important;
                display: block;
                top:10%;
              }
              .cricketx-scope .row {
                margin-left: 0 !important;
                margin-right: 0 !important;
              }
              .cricketx-scope .col-1,
              .cricketx-scope .col-6,
              .cricketx-scope .col-md-8,
              .cricketx-scope .col-md-6 {
                padding-left: 0 !important;
                padding-right: 0 !important;
              }
              .cricketx-scope .card-body {
                padding-left: 5px !important;
                padding-right: 5px !important;
              }
              .cricketx-scope .no-padding-mobile {
                padding-left: 0 !important;
                padding-right: 0 !important;
              }
              .cricketx-scope .exposure-balance-ctn {
                padding: 2px !important;
              }
            }
            .cricketx-scope .cricx-getting-bets-overlay {
              align-items: flex-start !important;
              justify-content: center;
              padding-top: 14px;
            }
            .cricketx-scope .cricx-getting-bets-inner {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 10px;
              padding: 0 16px;
              max-width: 320px;
              width: 100%;
            }
            .cricketx-scope .cricx-getting-bets-title {
              font-family: 'Roboto Condensed', 'Segoe UI', sans-serif;
              font-size: clamp(15px, 3.8vw, 20px);
              font-weight: 800;
              letter-spacing: 0.06em;
              color: #f8fafc;
              text-align: center;
              text-transform: uppercase;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.75),
                0 1px 0 rgba(0, 0, 0, 0.5);
            }
            .cricketx-scope .cricx-getting-bets-track {
              width: 100%;
              max-width: 280px;
              height: 10px;
              border-radius: 999px;
              background: #1e293b;
              overflow: hidden;
              box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.45);
            }
            /* Full green, then drain right->left (right edge moves left; origin left) */
            @keyframes cricketx-fetch-bets-once {
              0%,
              10% {
                width: 100%;
              }
              100% {
                width: 0%;
              }
            }
            @keyframes cricketx-fetch-bets-loop {
              0%,
              10% {
                width: 100%;
              }
              100% {
                width: 0%;
              }
            }
            .cricketx-scope .cricx-fetch-bets-fill-once {
              height: 100%;
              width: 100%;
              border-radius: 999px;
              background: linear-gradient(180deg, #4ade80 0%, #22c55e 55%, #16a34a 100%);
              box-shadow: 0 0 12px rgba(34, 197, 94, 0.45);
              transform-origin: left center;
            }
            .cricketx-scope .cricx-fetch-bets-overlay.overlayaviator {
              z-index: 20 !important;
              background: transparent !important;
              backdrop-filter: none !important;
              -webkit-backdrop-filter: none !important;
              align-items: flex-start !important;
              justify-content: center;
              padding-top: 152px;
              pointer-events: none;
            }
            @keyframes cricketx-out-drop {
              0% {
                transform: translate(-50%, calc(-50% - 46vh));
              }
              48% {
                transform: translate(-50%, -50%);
              }
              62% {
                transform: translate(-50%, calc(-50% - 26px));
              }
              74% {
                transform: translate(-50%, -50%);
              }
              86% {
                transform: translate(-50%, calc(-50% - 10px));
              }
              100% {
                transform: translate(-50%, -50%);
              }
            }
            .cricketx-scope .flight-timer.timer-crash {
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center;
              line-height: 1;
              padding: 0;
              animation: cricketx-out-drop 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
            }
            .cricketx-scope .flight-timer.timer-crash .crash-text {
              font-size: 0.45em;
              margin-bottom: 8px;
              letter-spacing: 0.06em;
            }
            .cricketx-scope .cricketx-title-heading {
              transform: translateY(-2px);
              margin-inline-start: 2px;
            }
            .cricketx-scope .bodyheight > .lobby-ctn + .card-body {
              margin-top: -8px !important;
              padding-top: 4px !important;
            }
            .cricketx-scope .home-content {
              margin-top: 0 !important;
            }
            .cricketx-scope .scroll-containeraviator .Connectedclients {
              position: relative;
              top: -8px;
              left: -24px;
            }
            .cricketx-scope .scroll-containeraviator .row > .col-1:last-child > div {
              position: relative !important;
              top: -10px;
              right: -24px;
              float: none;
            }
            .cricketx-scope .scroll-containeraviator .AVI-icon__signal-strength {
              transform: scale(0.9);
              transform-origin: center;
            }
            .cricketx-scope .scroll-containeraviator label.sound-icon[for="CricxSoundcontrol"] {
              transform: scale(0.76);
              transform-origin: bottom right;
              bottom: -33px !important;
              right: 19px !important;
            }
            @media (max-width: 576px) {
              .cricketx-scope .scroll-containeraviator .Connectedclients {
                left: -12px;
              }
              .cricketx-scope .scroll-containeraviator .row > .col-1:last-child > div {
                right: -9px;
              }
            }

            .counter-num {
              position: absolute;
              top: 10%; left: 50%;
              transform: translate(-50%, -50%);
              font-size: 80px;
              font-weight: 700;
              color: #fff;
              z-index: 5;
              text-shadow: 0 0 20px rgba(0,0,0,0.5);
            }
          `}
          </style>
          <div className="cricketx-scope">
            <div className="details-tabs-wrapper1">
              <div className="main-page">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <div className="bodyheight">
                      <div className="wrapper">
                        <TPStudioSidebar open={open} />
                      </div>

                      <div className="lobby-ctn BPGmaindiv">
                        <TpStudioHeader setOpen={setOpen} open={open} />
                      </div>

                      <div className="card-body">
                        <div className="row w-100">
                          <div className="col-md-8">
                            <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                              <div className="col-6 col-md-6 titlebarname inline-block Gameidcol mt-2">
                                <p
                                  className="cricketx-title-heading"
                                  style={{ fontSize: "18px" }}
                                >
                                  CRICKETX
                                </p>
                              </div>
                              <div
                                className="col-6 col-md-6 inline-block Gameidcol text-right"
                                style={{ marginTop: "4px" }}
                              >
                                <div
                                  role="group"
                                  aria-label="Second group"
                                  className="btn-group btn-group-sm mr-2"
                                >
                                  <button
                                    style={{
                                      fontSize: "14px",
                                      backgroundColor: "black"
                                    }}
                                    type="button"
                                    id="Alltab"
                                    onClick={() => activeTab(1)}
                                    className={
                                      activeTabIndex == 1
                                        ? "tablink btn btn-primary bbactive"
                                        : "tablink btn btn-primary"
                                    }
                                  >
                                    Game
                                  </button>
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    id="RESULTStab"
                                    className={
                                      activeTabIndex == 2
                                        ? "tablink btn btn-primary bbactive"
                                        : "tablink btn btn-primary"
                                    }
                                    onClick={() => activeTab(2)}
                                  >
                                    Results
                                  </button>
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    className="tablink btn btn-primary"
                                    onClick={() => setShowRules(true)}
                                  >
                                    Rules
                                  </button>
                                  <CricketRules
                                    show={showRules}
                                    onClose={() => setShowRules(false)}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Audio */}
                            <audio ref={bgAudioRef} src={BgSound} loop />

                            {/* Scene */}
                            <div
                              className="cards-layout blackjack font-familyAVE"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="scroll-containeraviator">
                                <div
                                  className="row cricketx-hud-row"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    padding: "10px",
                                    zIndex: 1200,
                                    pointerEvents: "auto"
                                  }}
                                >
                                  <div className="col-1">
                                    <div className="Connectedclients mt-1 ml-1 float-start">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          width: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          {luckyPlayerCount}
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                  <div className="col-10"></div>
                                  <div className="col-1">
                                    <div
                                      style={{
                                        float: "inline-end",
                                        position: "relative",
                                        zIndex: 1000
                                      }}
                                    >
                                      <i className="AVI-icon__signal-strength AVI-signal-0">
                                        <span
                                          className="AVI-bar-1"
                                          style={{
                                            backgroundColor: payload
                                              ? "rgb(0, 255, 0)"
                                              : "rgb(255, 0, 0)"
                                          }}
                                        ></span>
                                        <span
                                          className="AVI-bar-2"
                                          style={{
                                            backgroundColor: payload
                                              ? "rgb(0, 255, 0)"
                                              : "rgb(255, 0, 0)"
                                          }}
                                        ></span>
                                        <span
                                          className="AVI-bar-3"
                                          style={{
                                            backgroundColor: payload
                                              ? "rgb(0, 255, 0)"
                                              : "rgb(204, 204, 204)"
                                          }}
                                        ></span>
                                        <span
                                          className="AVI-bar-4"
                                          style={{
                                            backgroundColor: payload
                                              ? "rgb(0, 255, 0)"
                                              : "rgb(204, 204, 204)"
                                          }}
                                        ></span>
                                      </i>
                                    </div>
                                  </div>
                                </div>

                                {/* ===== Overlay: disconnected ===== */}
                                {!isConnected && (
                                  <div
                                    className="loading-game"
                                    style={{
                                      zIndex: 999,
                                      background: "rgba(0,0,0,0.85)"
                                    }}
                                  >
                                    <div className="center-loading text-center">
                                      <div
                                        className="waiting-text"
                                        style={{ color: "#ff4444" }}
                                      >
                                        <b>Connection Lost</b>
                                      </div>
                                      <div
                                        className="waiting-text"
                                        style={{
                                          fontSize: "14px",
                                          color: "#ccc"
                                        }}
                                      >
                                        Reconnecting...
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* ===== Overlay: waiting for next round ===== */}
                                {isConnected && scene === "waiting" && (
                                  <div className="loading-game">
                                    <div className="center-loading text-center">
                                      <div className="waiting-text">
                                        <b>Next round loading...</b>
                                      </div>
                                      <div className="line-loader">
                                        <div className="fill-line"></div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* ===== COUNTDOWN: cricket intro + countdown overlay ===== */}
                                {isConnected && scene === "countdown" && (
                                  <>
                                    {introPhase === "show1" && (
                                      <div className="overlayAnimation">
                                        <div
                                          className={`frame frame1 ${
                                            triger === "go" ? "scale-img" : ""
                                          }`}
                                        >
                                          <img src={Girlwithfl} alt="girl" />
                                          <img src={Girlwithfl2} alt="girl" />
                                          <img
                                            src={Girlwithflst}
                                            alt="girlwithflts"
                                          />
                                        </div>
                                      </div>
                                    )}

                                    {introPhase === "show2" && (
                                      <div className="overlayAnimation">
                                        <div
                                          className={`frame frame2 ${
                                            triger === "go2" ? "scale-img" : ""
                                          }`}
                                        >
                                          <img
                                            className="scale-img"
                                            src={Girlwithflst2}
                                            alt="girlwithflts"
                                          />
                                        </div>
                                      </div>
                                    )}

                                    {introPhase === "bowler" && (
                                      <div className="overlayAnimation">
                                        <div className="frame frame3">
                                          <img
                                            src={Ballerscreen}
                                            alt="playerseen"
                                          />
                                        </div>
                                      </div>
                                    )}

                                    {introPhase === "run" && (
                                      <div className="overlayAnimation">
                                        <div className="frame frame4">
                                          <img
                                            src={Running}
                                            alt="playerseen"
                                            style={{
                                              position: "absolute",
                                              left: "0",
                                              width: "300px"
                                            }}
                                          />
                                        </div>
                                      </div>
                                    )}

                                    {introPhase === "throw" && (
                                      <div className="overlayAnimation">
                                        <div className="frame frame5">
                                          <img
                                            src={ballerState}
                                            id="baller-img"
                                            alt="baller"
                                          />
                                          {ballerState === Ballerthrowing2 && (
                                            <img
                                              src={Ball}
                                              alt="ball"
                                              className={`baller_ball ${
                                                triger === "move_ball"
                                                  ? "move_ball_baller"
                                                  : ""
                                              }`}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {introPhase === "hit" && (
                                      <div className="overlayAnimation">
                                        <div className="frame frame6">
                                          <img
                                            src={batterState}
                                            className="batsman-img"
                                            alt="batsman"
                                          />
                                          <img
                                            src={Keeper}
                                            className="keeper"
                                            alt="keeper"
                                          />
                                          <img
                                            src={Ball}
                                            alt="ball"
                                            className={`batsman_ball ${
                                              triger === "move_ball_batter"
                                                ? "move_ball_batter"
                                                : ""
                                            } ${
                                              triger === "ball_hit"
                                                ? "move_ball_hited"
                                                : ""
                                            }`}
                                          />
                                        </div>
                                      </div>
                                    )}

                                    {introPhase === "ball-flight" && (
                                      <div className="overlayAnimation">
                                        <div
                                          className={`frame frame7 ${
                                            triger === "ball_hit"
                                              ? "zoom-in"
                                              : ""
                                          }`}
                                        ></div>
                                      </div>
                                    )}
                                  </>
                                )}

                                {/* ===== FLIGHT: ball-spin with multiplier ===== */}
                                {scene === "flight" && (
                                  <>
                                    <div className="overlayAnimation">
                                      <div className="frame">
                                        <div className="cloud-layer">
                                          <img
                                            className="cloud c1"
                                            src={Cloud1}
                                            alt=""
                                          />
                                          <img
                                            className="cloud c2"
                                            src={Cloud2}
                                            alt=""
                                          />
                                          <img
                                            className="cloud c3"
                                            src={Cloud3}
                                            alt=""
                                          />
                                          <img
                                            className="cloud c4"
                                            src={Cloud4}
                                            alt=""
                                          />
                                          <div className="ball-wrapper">
                                            <img
                                              className="ball-flame"
                                              src={ballFlame}
                                              alt=""
                                            />
                                            <img
                                              className="ball-spin spin"
                                              id="ball-spin"
                                              src={Ball}
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {flightValue > 0 && (
                                      <div className="counter-num">
                                        {flightValue.toFixed(2)}x
                                      </div>
                                    )}
                                  </>
                                )}

                                {/* ===== CRASHED: centered OUT + score ===== */}
                                {scene === "crashed" && (
                                  <>
                                    <div className="overlayAnimation">
                                      <div className="frame"></div>
                                    </div>
                                    {flightValue > 0 && (
                                      <div className="flight-timer timer-crash">
                                        <div className="crash-text">OUT!</div>
                                        {flightValue.toFixed(2)}x
                                      </div>
                                    )}
                                  </>
                                )}

                                {/* Scrolling terrain placeholder */}
                                <div
                                  id="toshakecontent"
                                  className="w-100 p-0"
                                ></div>

                                {/* GETTING THE BETS on first cheer-girls screen, or while placing */}
                                {(showRoundGettingBets || isPlacingBets) &&
                                  scene !== "flight" &&
                                  scene !== "crashed" && (
                                    <div
                                      key={
                                        showRoundGettingBets
                                          ? "round-getting-bets"
                                          : fetchBetAnimKey
                                      }
                                      className="overlayaviator cricx-getting-bets-overlay cricx-fetch-bets-overlay"
                                      style={{ zIndex: 20 }}
                                      role="status"
                                      aria-live="polite"
                                      aria-busy="true"
                                    >
                                      <div className="cricx-getting-bets-inner">
                                        <div className="cricx-getting-bets-title">
                                          GETTING THE BETS
                                        </div>
                                        <div className="cricx-getting-bets-track">
                                          <div
                                            className="cricx-fetch-bets-fill-once"
                                            style={{
                                              animation: showRoundGettingBets
                                                ? `cricketx-fetch-bets-loop ${FETCH_BET_ANIM_MS}ms cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite`
                                                : `cricketx-fetch-bets-once ${FETCH_BET_ANIM_MS}ms cubic-bezier(0.45, 0.05, 0.55, 0.95) forwards`
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                {/* Sound toggle */}
                                <label
                                  htmlFor="CricxSoundcontrol"
                                  className={`fa fa-inverse sound-icon fa-2x ${
                                    soundEnabled
                                      ? "fa-volume-up"
                                      : "fa-volume-off"
                                  }`}
                                  style={{
                                    position: "absolute",
                                    right: 8,
                                    bottom: 8,
                                    zIndex: 100,
                                    cursor: "pointer"
                                  }}
                                  title="Toggle sound"
                                >
                                  <input
                                    id="CricxSoundcontrol"
                                    type="checkbox"
                                    checked={soundEnabled}
                                    onChange={toggleSound}
                                    style={{ display: "none" }}
                                  />
                                </label>
                              </div>
                            </div>
                            {/* /Scene */}

                            {/* Results history & Round ID */}
                            <center
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                <div className="buttons-div">
                                  {lastTenResults.length > 0
                                    ? lastTenResults.map((val, idx) => (
                                        <button
                                          key={idx}
                                          className="video-button border-gradient-btn border-gradient-purple-btn"
                                        >
                                          {val.toFixed(2)}
                                        </button>
                                      ))
                                    : null}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{roundId || "--"}</div>
                                </div>
                              </div>
                            </center>

                            {/* Two-sided betting panels */}
                            <div
                              className="cricx-container"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              {/* Left side */}
                              {renderBetPanel("left")}

                              {/* Right side */}
                              {renderBetPanel("right")}
                            </div>
                            <div
                              style={{
                                display: activeTabIndex == 2 ? "" : "none"
                              }}
                            >
                              <AvaitorResult resultData={resultData} />
                            </div>
                          </div>
                          {/* Right sidebar - Lucky Players */}
                          <div className="col-md-4">
                            <div className="right-content">
                              <div className="card" style={{ border: "0px" }}>
                                <div
                                  className="card-header"
                                  id="headingTwo"
                                  style={{
                                    padding: "0px",
                                    background: "#23292d"
                                  }}
                                >
                                  <h2
                                    className="mb-0"
                                    style={{
                                      background: "var(--theme-color)",
                                      borderRadius: "0px"
                                    }}
                                  >
                                    <button
                                      className="btn btn-link btn-block text-left"
                                      type="button"
                                      style={{
                                        color: "white",
                                        textDecoration: "none"
                                      }}
                                    >
                                      Lucky Players{" "}
                                      <span id="totalLuckyPlayers">
                                        {luckyPlayerCount}
                                      </span>
                                    </button>
                                  </h2>
                                </div>
                                <div style={{ backgroundColor: "#2e3438" }}>
                                  <div
                                    className="card-body"
                                    style={{ padding: 0, minHeight: "40px" }}
                                  >
                                    <div
                                      id="refreshhistory"
                                      style={{
                                        paddingLeft: 0,
                                        width: "100%",
                                        height: "400px",
                                        maxHeight: "400px",
                                        overflowY: "auto",
                                        overflowX: "hidden"
                                      }}
                                    >
                                      <table className="table blastoff-table">
                                        <thead>
                                          <tr>
                                            <th>User</th>
                                            <th>Size</th>
                                            <th>Price</th>
                                            <th>Profit</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {betsList && betsList.length > 0 ? (
                                            betsList.map((bet) => (
                                              <tr
                                                key={bet.id}
                                                style={{
                                                  backgroundColor: "#eff8ff",
                                                  color: "#000",
                                                  fontSize: "13px",
                                                  textAlign: "center"
                                                }}
                                              >
                                                <td
                                                  style={{
                                                    textAlign: "left",
                                                    fontSize: "13px"
                                                  }}
                                                >
                                                  {bet.uname}
                                                </td>
                                                <td
                                                  style={{ fontSize: "13px" }}
                                                >
                                                  {bet.amount}
                                                </td>
                                                <td
                                                  style={{ fontSize: "13px" }}
                                                >
                                                  {bet.rate}
                                                </td>
                                                <td
                                                  style={{
                                                    textAlign: "center",
                                                    fontSize: "13px"
                                                  }}
                                                >
                                                  {bet.profit || "--"}
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr
                                              style={{
                                                background: "#333333",
                                                border: "1px solid #000",
                                                color: "#fff",
                                                fontSize: "12px",
                                                textAlign: "center"
                                              }}
                                            >
                                              <td colSpan="4">
                                                No placed bet found!
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>{" "}
                          {/*  ends here  */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ClientLayoutWithOutHeader>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        closeButton={false}
        newestOnTop
        limit={1}
      />
      <style>
        {`
          .av-win-toast,
          .av-bet-toast,
          .av-lost-toast {
            border-radius: 8px !important;
            padding: 12px 20px !important;
            min-height: unset !important;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.38) !important;
            overflow: hidden;
          }
          .av-win-toast {
            background: #2d7a3a !important;
          }
          .av-bet-toast {
            background: #43a047 !important;
          }
          .av-lost-toast {
            background: #c62828 !important;
          }
          .av-win-toast .Toastify__toast-body,
          .av-bet-toast .Toastify__toast-body,
          .av-lost-toast .Toastify__toast-body {
            padding: 0 !important;
            margin: 0 !important;
          }
          .av-win-toast .Toastify__progress-bar,
          .av-bet-toast .Toastify__progress-bar,
          .av-lost-toast .Toastify__progress-bar {
            background: rgba(0, 0, 0, 0.2) !important;
            height: 4px;
          }
          .av-toast-body {
            display: flex;
            align-items: center;
            gap: 12px;
            color: #ffffff;
            font-size: 18px;
            font-weight: 600;
            line-height: 1.2;
            white-space: nowrap;
          }
          .av-toast-icon {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
          }
          .av-win-toast-icon-svg,
          .av-toast-icon svg {
            display: block;
            width: 24px;
            height: 24px;
          }
          .av-toast-text {
            padding-top: 1px;
          }
        `}
      </style>
    </>
  );
}
